import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button, Checkbox,
    Fade,
    FormControl,
    FormControlLabel,
    FormGroup,
    Grid,
    List, ListItem, ListItemIcon,
    ListItemText,
    MenuItem,
    Modal,
    Select,
    Stack,
    Switch,
    TextField,
    Typography,
    InputLabel,
    OutlinedInput
} from '@mui/material';
import { styled } from '@mui/material/styles';
import _, { update } from "lodash";
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { ReactComponent as AddBtnIcon } from "../assets/icons/icon-add-btn-plain.svg";

import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
import { makeStyles } from '@mui/styles';
import toast from 'react-hot-toast';
import ReactSelect from 'react-select';
import { ReactComponent as DropDownIcon } from "../assets/icons/icon-angle-down.svg";
import Controls from '../components/controls/Controls';
import { getMeasuresList } from '../config/services/measures';
import { getAllReports, getReportsList } from '../config/services/reports';
import { CamelToNormalString, convertPivotConfig, formatOrderBy } from '../utils/Reusables';
import ReportMetrics from './sub/ReportMetrics';
//import { currencies } from 'currencies.json';
import { ReactComponent as CenterAlignmentIcon } from "../assets/icons/icon-alignment-center.svg";
import { ReactComponent as LeftAlignmentIcon } from "../assets/icons/icon-alignment-left.svg";
import { ReactComponent as RightAlignmentIcon } from "../assets/icons/icon-alignment-right.svg";
import { ReactComponent as CancelIcon } from "../assets/icons/icon-cross.svg";
import { getIconsList } from '../config/services/icon';
import { getDashboardList as getPublishedDashboardList } from '../config/services/publishDashboard';
import { NumberGraphTemplates } from "../layouts/graph/GraphTypesConfig";
import { CURRENCIES } from '../constants/filterType';
import MergeReportSetting from './reportSetting/MergeReportSetting';

const RootStyle = styled('div')(({ theme }) => ({
    [theme.breakpoints.up('lg')]: {
        flexShrink: 0,
    },
}));

const useStyles = makeStyles((theme) => ({
    fieldMenu: {
        boxShadow: '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)',
    },
    fieldBtn: {
        position: 'absolute',
        right: '5px',
        bottom: '3px',
        cursor: 'pointer',
    },
    reportFieldList: {
        width: '100%',
        backgroundColor: '#fff',
        maxHeight: '350px',
        minHeight: '350px',
        overflowY: 'auto',
        marginBottom: '1rem',
    },
    bgWhite: {
        backgroundColor: '#fff',
        borderRadius: '4px',
    },
    reportSettingsSection: {

    },
    menuDropdownItem: {
        fontSize: '14px',
        color: '#202124',
        '&:hover': {
            backgroundColor: '#f6f6f6'
        }
    }

}));

const horizontalScrollChartTypes = ['bar', 'line', 'horizontalBar', 'clusteredBarCombo', 'stackedBarCombo', 'multiAxisBarCombo', 'scatter', 'histogram', 'area']
const tableChartTypes = ['table', 'pivotTable']

export default function ReportSettings({ reportDetails, updateReportDetails, dimensionTitle, measureTitle, handleDimensionTitleChange, handleMeasureTitleChange, handleSaveTitle, commonFields, setCommonFields, hyperlinkCount, setHyperlinkCount, setSelectedReportTab }) {
    const classes = useStyles()
    const [titles, setTitles] = useState(reportDetails?.reportDetails?.formatVisual?.titles)
    const [measTitle, setMeasTitle] = useState(measureTitle)
    const [dimTitle, setDimTitle] = useState(dimensionTitle)
    const [measureList, setMeasureList] = useState([])
    const [dateFieldList, setDateFieldMeasureList] = useState([])
    const [linkableReports, setLinkableReports] = useState([])
    const [openMetricsModal, setOpenMetricsModal] = useState(false);
    const [otherSettingsRowsPerPageModal, setOtherSettingsRowsPerPageModal] = useState(false);
    const [otherSettingsData, setOtherSettingsData] = useState({
        pageSize: reportDetails?.reportDetails?.settings?.pageSize,
        alignment: { ...reportDetails?.reportDetails?.settings?.alignment }
    })
    const [otherSettingsalignmentModal, setOtherSettingsAlignmentModal] = useState(false);
    const [conditionalFormat, setConditionalFormat] = useState(reportDetails?.reportDetails?.settings?.conditionalFormat)

    const modalRef = React.useRef(null);
    const [customInputTableHeader, setCustomInputTableHeader] = React.useState(false);
    const [customInputDimensions, setCustomInputDimensions] = React.useState(false);
    const [formatDropdownStatus, setFormatDropdownStatus] = React.useState(false);
    const [periodicityDropdownStatus, setPeriodicityDropdownStatus] = React.useState(false);
    const [periodicityCustomStatus, setPeriodicityCustomStatus] = React.useState(reportDetails?.reportDetails?.settings?.rateChangeProps?.isCustom || false);
    const [customPeriod, setCustomPeriod] = useState(reportDetails?.reportDetails?.settings?.rateChangeProps?.customVal || '');
    const [customPeriodLabel, setCustomPeriodLabel] = useState(reportDetails?.reportDetails?.settings?.rateChangeProps?.periodicity || '');
    const [formatValue, setFormatValue] = React.useState(null);
    const [formatTimeValue, setFormatTimeValue] = React.useState(null);
    const [formatCurrencyValue, setFormatCurrencyValue] = React.useState(null);
    const [numberChartTemplateSeletedIndex, setNumberChartTemplateSeletedIndex] = React.useState(null);
    const [fillMissingDates, setFillMissingDate] = useState(reportDetails?.reportDetails?.settings?.fillMissingDates || false)
    const [iconList, setIconList] = useState([]);
    const [mobileDataToDisplay, setMobileDataToDisplay] = useState([{}])
    const [mobileColumns, setMobileColumns] = useState(reportDetails?.reportDetails?.settings?.mobile?.measureToDiplay)

    useEffect(() => {
        let measure = reportDetails?.reportDetails?.measures
        let dimension = reportDetails?.reportDetails?.dimensions
        let mergedArray = measure?.concat(dimension);

        if (reportDetails?.reportDetails?.settings?.groupBySettings?.length) {
            let concat = []
            reportDetails?.reportDetails?.settings?.groupBySettings?.forEach(setting => {
                concat = [...concat, ...setting?.concatWith]
            })
            mergedArray = mergedArray.filter(element => {
                return !concat?.includes(element?.fieldName)
            })
        }
        setMobileDataToDisplay(mergedArray)
    }, [reportDetails?.reportDetails?.measure, reportDetails?.reportDetails?.dimension])

    const formattedOptions = mobileDataToDisplay?.map((option) => ({
        label: option?.displayName ? option?.displayName : option?.fieldName?.split('.')?.[1],
        value: option?.fieldName,
    }));


    useEffect(() => {
        getIconsList()
            .then(res => {
                setIconList(res)
            })
            .catch(err => {
                console.log('icons list error', err)
            })
    }, [])

    useEffect(() => {
        if (numberChartTemplateSeletedIndex === null && reportDetails?.reportDetails?.settings?.numberChartTemplate?.template) {
            let selectedIndex = NumberGraphTemplates.findIndex(item => item.value === reportDetails?.reportDetails?.settings?.numberChartTemplate?.template)
            const index = selectedIndex > -1 ? selectedIndex : null
            setNumberChartTemplateSeletedIndex(index)
        }
    }, [reportDetails?.reportDetails?.settings?.numberChartTemplate?.template])
    const toggleTableHeaderDropdown = () => {
        if (customInputTableHeader) {
            setCustomInputTableHeader(false);
        } else {
            setCustomInputTableHeader(true);
        }
    }
    const toggleDimensionsDropdown = () => {
        if (customInputDimensions) {
            setCustomInputDimensions(false);
        } else {
            setCustomInputDimensions(true);
        }
    }

    const customInputDimensionsSelected = (val) => {
        setOtherSettingsData(prev => ({ ...prev, alignment: { ...prev?.alignment, dimensions: val } }))
    }

    const customInputTableHeaderSelected = (val) => {
        setOtherSettingsData(prev => ({ ...prev, alignment: { ...prev?.alignment, header: val } }))
    }

    const handleAlignmentSetting = (type) => {
        if (type === 'cancel') {
            setOtherSettingsData(prev => ({ ...prev, alignment: { ...reportDetails?.reportDetails?.settings?.alignment } }))
            setOtherSettingsAlignmentModal(false)
        }
        else if (type === 'save') {

            const cloned = _.cloneDeep(reportDetails?.reportDetails)
            cloned.settings.alignment = { ...otherSettingsData?.alignment }
            updateReportDetails({ reportDetails: cloned })
            setOtherSettingsAlignmentModal(false)
        }
    }

    const handlePageSize = (type) => {
        if (type === 'cancel') {
            setOtherSettingsData(prev => ({ ...prev, pageSize: reportDetails?.reportDetails?.settings?.pageSize }))
            setOtherSettingsRowsPerPageModal(false)
        }
        else if (type === 'save') {

            if (otherSettingsData?.pageSize !== 0 && !otherSettingsData?.pageSize) {
                toast.error('PageSize is required!')
                return
            }
            const cloned = _.cloneDeep(reportDetails?.reportDetails)
            cloned.settings.pageSize = otherSettingsData?.pageSize
            updateReportDetails({ reportDetails: cloned })
            setOtherSettingsRowsPerPageModal(false)
        }
    }

    useEffect(async () => {
        let isShowRateChange = reportDetails?.reportDetails?.settings?.rateChangeProps?.showRateChange
        let dataSetId = reportDetails?.reportDetails?.dataSetId?._id
        if (isShowRateChange) {
            let res = await getMeasuresList({ dataSetId: dataSetId })
            if (res?.result?.length) {
                let timeMeasures = res?.result?.filter(obj => obj?.type === 'time')
                setDateFieldMeasureList(timeMeasures)
            }
        }
    }, [reportDetails?.reportDetails?.settings?.rateChangeProps?.showRateChange])


    const handleMeasTitleChange = (e, fieldName) => {
        const { value } = e.target
        setMeasTitle((prev) => ({ ...prev, [fieldName]: value }));
        handleMeasureTitleChange(e, fieldName)
    }

    const handleDimTitleChange = (e, fieldName) => {
        const { value } = e.target
        setDimTitle((prev) => ({ ...prev, [fieldName]: value }));
        handleDimensionTitleChange(e, fieldName)
    }

    const handleLegendVisibility = (e) => {
        let { checked } = e.target
        reportDetails.reportDetails.isLegendVisible = checked;
        updateReportDetails({ reportDetails: reportDetails.reportDetails })
    }

    const handleRenewQuery = (e) => {
        let { checked } = e.target
        reportDetails.reportDetails.renewQuery = checked;
        updateReportDetails({ reportDetails: reportDetails.reportDetails })
    }

    const handleLegendPosition = e => {
        let { value } = e.target
        reportDetails.reportDetails.legendPosition = value;
        //console.log(reportDetails)
        updateReportDetails({ reportDetails: reportDetails.reportDetails })
    }

    const handleTitlesChange = (e, type) => {
        let { name, value, checked } = e.target
        let updatedTitles = { ...titles }

        switch (type) {
            case 'text':
                updatedTitles[name] = value
                break
            case 'checkbox':
                updatedTitles[name] = checked
                break
        }
        reportDetails.reportDetails.formatVisual = { ...reportDetails?.reportDetails?.formatVisual, titles: updatedTitles };

        /** 
         * This piece of code will save Title/ Subtitle Seperately and will change and save Report Name/Description also.
         * Meanwhile Title/Subtitle will be same as Report Name/Description and saved seperately with same value for future purposes.
        */

        switch (name) {
            case 'title':
                reportDetails.reportDetails.reportName = value
                break
            case 'subTitle':
                reportDetails.reportDetails.description = value
                break
        }
        updateReportDetails({ reportDetails: reportDetails.reportDetails })

        setTitles(updatedTitles)
    }


    const handleNoDataText = (e) => {
        const text = e.target.value;
        reportDetails.reportDetails.noDataText = text;
        updateReportDetails({ reportDetails: reportDetails.reportDetails })
    }

    const handleLinkedReportView = (e) => {
        let { name, value } = e.target
        reportDetails.reportDetails[name] = value
        updateReportDetails({ reportDetails: reportDetails.reportDetails })
    }

    const handleCarouselCardSpacing = (e, device) => {
        let { name, value } = e.target
        let settingsObj = { mobile: {}, web: {} }

        if (reportDetails?.reportDetails?.settings) settingsObj = _.cloneDeep(reportDetails?.reportDetails?.settings)
        settingsObj[device][name] = value
        reportDetails.reportDetails.settings = settingsObj;
        updateReportDetails({ reportDetails: reportDetails.reportDetails })
    }

    const handleColorChange = (e) => {
        let { name, value } = e.target
        let settingsObj = { mobile: {}, web: {} }

        if (reportDetails?.reportDetails?.settings)
            settingsObj = _.cloneDeep(reportDetails?.reportDetails?.settings)

        settingsObj[name] = value
        reportDetails.reportDetails.settings = settingsObj;
        updateReportDetails({ reportDetails: reportDetails.reportDetails })
    }

    const handleBgColorChange = (e, device) => {
        let { name, value } = e.target
        // console.log("uu", e)
        let settingsObj = { mobile: {}, web: {} }

        if (reportDetails?.reportDetails?.settings)
            settingsObj = _.cloneDeep(reportDetails?.reportDetails?.settings)

        settingsObj[device][name] = value
        reportDetails.reportDetails.settings = settingsObj;
        updateReportDetails({ reportDetails: reportDetails.reportDetails })
    }

    const debounceFnColorChange = useCallback(_.debounce(handleColorChange, 100), []);

    const debounceFnBgColorChange = useCallback(_.debounce(handleBgColorChange, 100), []);

    const handleSettings = (e, device, type) => {
        let { name, checked, value } = e.target
        let settingsObj = { mobile: {}, web: {} }
        if (reportDetails?.reportDetails?.settings) {
            settingsObj = _.cloneDeep(reportDetails?.reportDetails?.settings)
        }

        if (type === 'input' && value > 10000) {
            return
        }

        switch (device) {
            case 'mobile':
                switch (type) {
                    case 'checkbox':
                        settingsObj['mobile'][name] = checked
                        break;
                    case 'input':
                        settingsObj['mobile'][name] = value
                        break;
                }
                break;
            case 'web':
                switch (type) {
                    case 'checkbox':
                        settingsObj['web'][name] = checked
                        break;
                    case 'input':
                        settingsObj['web'][name] = value
                        break;
                }
                break;

            default:
                switch (type) {
                    case 'checkbox':
                        settingsObj[name] = checked
                        break;
                    case 'input':
                        settingsObj[name] = value
                        break;
                }
                break;
        }
        reportDetails.reportDetails.settings = settingsObj;
        updateReportDetails({ reportDetails: reportDetails.reportDetails })
    }


    const handleLinkReportAccordion = (e, expanded) => {
        if (!linkableReports?.length && expanded) {
            getAllReports()
                .then(response => {
                    if (response?.data?.statusCode === 0) {
                        return
                    }

                    let filtered = [];
                    if (response?.result?.length) {
                        filtered = response?.result.filter(report => report?.reportName !== reportDetails?.reportDetails?.reportName)
                    }
                    setLinkableReports(filtered ?? [])
                })
        }
    }
    const handleLinkReports = (options) => {
        let selectedReports = options?.map(obj => {
            if (!obj?.reportId?._id) {
                const pivotConfig = convertPivotConfig(obj?.pivotConfig, obj);
                const orderBy = formatOrderBy(obj?.orderBy, obj);

                obj.pivotConfig = pivotConfig;
                obj.orderBy = orderBy;

                return { reportId: { ...obj }, _id: obj._id, reportName: obj.reportName }
            }
            else {
                return obj
            }
        })
        let clonedReportDetails = _.cloneDeep(reportDetails)
        if (selectedReports?.length === 0) {
            // clear all settings done in linked reports
            clonedReportDetails.reportDetails.carouselName = '';
            clonedReportDetails.reportDetails.carouselDescription = '';
            clonedReportDetails.reportDetails.linkedReportsViewCountMobile = 0;
            clonedReportDetails.reportDetails.linkedReportsViewCount = 1;
            clonedReportDetails.reportDetails.linkedReportsViewType = 'TAB';
            clonedReportDetails.reportDetails.tabName = '';
        }


        clonedReportDetails.reportDetails.linkedReports = selectedReports;
        setSelectedReportTab(0)
        updateReportDetails({ reportDetails: clonedReportDetails.reportDetails })
    }


    const handleLinkedReportTabName = (e, index) => {
        let { value } = e.target
        let { linkedReports } = reportDetails?.reportDetails ?? {}
        let LinkedReportsCloned = []

        if (linkedReports) {
            LinkedReportsCloned = _.cloneDeep(linkedReports)
        }

        if (LinkedReportsCloned[index] && value?.length <= 200) {
            LinkedReportsCloned[index].tabName = value;
            reportDetails.reportDetails.linkedReports = LinkedReportsCloned

            updateReportDetails({ reportDetails: reportDetails.reportDetails })
        }
    }


    const handleReportTabName = (e) => {
        let { value } = e.target
        reportDetails.reportDetails.tabName = value;
        updateReportDetails({ reportDetails: reportDetails?.reportDetails })
    }

    const debouncedRef = React.useRef(null)

    const handleReportCarouselName = async (e, reportId) => {
        if (debouncedRef.current) {
            clearTimeout(debouncedRef.current)
            debouncedRef.current = null
        }

        const timeout = setTimeout(() => {
            let { value } = e.target
            if (reportId) {
                let clonedReportDetails = _.cloneDeep(reportDetails)
                clonedReportDetails.reportDetails.linkedReports = clonedReportDetails.reportDetails?.linkedReports?.map(_report => {
                    if (_report._id == reportId) {
                        _report.carouselName = value
                    }
                    return _report
                })
                updateReportDetails({ reportDetails: clonedReportDetails.reportDetails });
                return
            }
            reportDetails.reportDetails.carouselName = value
            updateReportDetails({ reportDetails: reportDetails?.reportDetails })
        }, 500);
        debouncedRef.current = timeout
    }

    const handleReportCarouselDescription = async (e, reportId) => {
        if (debouncedRef.current) {
            clearTimeout(debouncedRef.current)
            debouncedRef.current = null
        }
        const timeout = setTimeout(() => {
            let { value } = e.target
            if (reportId) {
                let clonedReportDetails = _.cloneDeep(reportDetails)
                clonedReportDetails.reportDetails.linkedReports = clonedReportDetails.reportDetails?.linkedReports?.map(_report => {
                    if (_report._id == reportId) {
                        _report.carouselDescription = value
                    }
                    return _report
                })
                updateReportDetails({ reportDetails: clonedReportDetails.reportDetails });
                return
            }
            reportDetails.reportDetails.carouselDescription = value
            updateReportDetails({ reportDetails: reportDetails?.reportDetails })
        }, 500);
        debouncedRef.current = timeout

    }

    const handleMetricsClose = () => {
        setOpenMetricsModal(false);
    }
    const handleConditionalFormat = ({ type, currentFormat, index, handleAccordionState }) => {
        if (type === 'cancel') {
            handleAccordionState(index)
            return
        }
        else if (type === 'save') {
            const { columnName, visualType, color, showNumber, alignment, decimalPrecision, showTarget, targetValue } = currentFormat;

            if (reportDetails?.reportDetails?.chartType === 'table') {
                if (!columnName) {
                    toast.error('Column is required!')
                    return
                }
                if (!visualType) {
                    toast.error('VisualType is required!')
                    return
                }
                if ((visualType === 'heatMap' || visualType === 'bar') && !color) {
                    toast.error('Color is required!')
                    return
                }
                if (showNumber && !alignment) {
                    toast.error('Alignment is required!')
                    return
                }
                if (showTarget && !targetValue) {
                    toast.error('Target Value is required!')
                    return
                }
                if (targetValue > 100 && targetValue < 1) {
                    toast.error('Target Value should be less than or equal to 100!')
                    return

                }
            }
            else {
                if (!columnName) {
                    toast.error('Column is required!')
                    return
                }
                if (columnName && !decimalPrecision) {
                    toast.error('Decimal Precision is required!')
                    return
                }
            }

            let clonedReportDetails = _.cloneDeep(reportDetails?.reportDetails)
            clonedReportDetails.settings.conditionalFormat[index] = currentFormat
            let clonedConditionalFormat = _.cloneDeep(conditionalFormat)
            clonedConditionalFormat[index] = currentFormat
            setConditionalFormat(clonedConditionalFormat)
            updateReportDetails({ reportDetails: clonedReportDetails })
            handleAccordionState(index)
        }
    }
    const addMoreFormat = () => {
        let currentFormat = _.cloneDeep(conditionalFormat)
        currentFormat.push({})
        setConditionalFormat(currentFormat)
    }

    const removeFormat = (e, index) => {
        let currentFormat = _.cloneDeep(conditionalFormat)
        let clonedReport = _.cloneDeep(reportDetails?.reportDetails)
        currentFormat.splice(index, 1)
        clonedReport?.settings?.conditionalFormat.splice(index, 1)
        setConditionalFormat(currentFormat)
        updateReportDetails({ reportDetails: clonedReport })

    }

    const handleRateDateField = (e) => {
        let clonedReportDetails = _.cloneDeep(reportDetails?.reportDetails)
        const { value } = e?.target
        clonedReportDetails.settings.rateChangeProps.dateField = `${clonedReportDetails?.dataSetId?.dataSetName}.${value}`
        updateReportDetails({ reportDetails: clonedReportDetails })
    }

    const handleDataFormat = (e, type) => {
        const { value } = e?.target
        //console.log(value)
        if (value) {
            let clonedReportDetails = _.cloneDeep(reportDetails?.reportDetails)
            switch (type) {
                case 'currency':
                    clonedReportDetails.settings.dataFormat.currencyFormat = value
                    clonedReportDetails.settings.dataFormat.timeFormat = ''
                    clonedReportDetails.settings.dataFormat.format = ''
                    break;
                case 'time':
                    clonedReportDetails.settings.dataFormat.timeFormat = value
                    clonedReportDetails.settings.dataFormat.currencyFormat = ''
                    clonedReportDetails.settings.dataFormat.format = ''
                    break;
                default:
                    clonedReportDetails.settings.dataFormat.format = value
                    clonedReportDetails.settings.dataFormat.timeFormat = ''
                    clonedReportDetails.settings.dataFormat.currencyFormat = ''
                    break
            }
            updateReportDetails({ reportDetails: clonedReportDetails })
        }

    }

    const handleShowRateChange = (e) => {
        const { checked } = e?.target;
        const clonedReportDetails = _.cloneDeep(reportDetails?.reportDetails);
        if (checked === false) {
            clonedReportDetails.settings.rateChangeProps = {}
        }
        else {
            clonedReportDetails.settings.rateChangeProps.showRateChange = checked
        }
        updateReportDetails({ reportDetails: clonedReportDetails })
    }

    const handleShowYearOnYearChange = (e) => {
        const { checked } = e?.target;
        const clonedReportDetails = _.cloneDeep(reportDetails?.reportDetails);
        clonedReportDetails.settings.rateChangeProps.showYearOnYearChange = checked
        updateReportDetails({ reportDetails: clonedReportDetails })
    }


    const handleReportAxisSettings = _.debounce(
        async (e) => {
            const clonedReport = await _.cloneDeep(reportDetails?.reportDetails)
            const { value, name } = e?.target
            //console.log(value)
            switch (name) {
                case 'x-axis-title':
                    clonedReport.settings.axisTitle["x"] = { "text": value }
                    break
                case 'y-axis-title':
                    clonedReport.settings.axisTitle["y"] = { "text": value }
                    break
                case 'y-axis-interval':
                    clonedReport.settings.axisSettings["y"].left = { ...clonedReport?.settings?.axisSettings?.["y"]?.left, "interval": value > -1 ? Number(value): 0 }
                    break
                case 'y-axis-max-value':
                    clonedReport.settings.axisSettings["y"].left = { ...clonedReport?.settings?.axisSettings?.["y"]?.left, "max": value > -1 ? Number(value): 0 }
                    break
                case 'y-axis-right-title':
                    clonedReport.settings.axisTitle["z"] = { "text": value }
                    break
                case 'y-axis-right-interval':
                    clonedReport.settings.axisSettings["y"].right = { ...clonedReport?.settings?.axisSettings?.["y"]?.right, "interval": value > -1 ? Number(value): 0 }
                    break
                case 'y-axis-right-max-value':
                    clonedReport.settings.axisSettings["y"].right = { ...clonedReport?.settings?.axisSettings?.["y"]?.right, "max": value > -1 ? Number(value): 0 }
                    break
                default:
                    return
            }
            //console.log(clonedReport)
            updateReportDetails({ reportDetails: clonedReport })
        },
        300
    );

    const handleRatePeriod = (type) => {
        const clonedReportDetails = _.cloneDeep(reportDetails?.reportDetails);
        if (type === 'custom') {
            if (!customPeriod) {
                toast.error('Custom Period is required!')
                return
            }
            clonedReportDetails.settings.rateChangeProps.isCustom = true;
            clonedReportDetails.settings.rateChangeProps.customVal = customPeriod;

            let customLabel = '';
            if (!customPeriodLabel) {
                if (Number(customPeriod) === 7)
                    customLabel = 'Weekly'
                else if (Number(customPeriod) === 30)
                    customLabel = 'Monthly'
                else if (Number(customPeriod) === 360)
                    customLabel = 'Yearly'
                else
                    customLabel = `Last ${customPeriod} days`
            }

            if (customLabel) {
                setCustomPeriodLabel(customLabel)
                clonedReportDetails.settings.rateChangeProps.periodicity = customLabel
            }
            else {
                setCustomPeriodLabel(customPeriodLabel)
                clonedReportDetails.settings.rateChangeProps.periodicity = customPeriodLabel
            }
        }
        else {
            setPeriodicityCustomStatus(false)
            setCustomPeriod('')
            clonedReportDetails.settings.rateChangeProps.isCustom = false;
            clonedReportDetails.settings.rateChangeProps.customVal = ''
            clonedReportDetails.settings.rateChangeProps.periodicity = type
        }
        updateReportDetails({ reportDetails: clonedReportDetails })
    }

    const handleNumberChartTemplate = async (value, index) => {
        const clonedReportDetails = _.cloneDeep(reportDetails?.reportDetails);
        const numberChartTemplate = clonedReportDetails.settings.numberChartTemplate || {}
        clonedReportDetails.settings.numberChartTemplate = { ...numberChartTemplate, template: value }
        updateReportDetails({ reportDetails: clonedReportDetails });
        setNumberChartTemplateSeletedIndex(index)
    }

    const handleNumberChartTemplateColor = async (event) => {
        const { value } = event?.target
        const clonedReportDetails = _.cloneDeep(reportDetails?.reportDetails);
        const config = clonedReportDetails.settings.numberChartTemplate.config || {}
        clonedReportDetails.settings.numberChartTemplate.config = { ...config, color: value }
        updateReportDetails({ reportDetails: clonedReportDetails })
    }

    const handleNumberChartIcon = async (event) => {
        const { value } = event?.target
        const clonedReportDetails = _.cloneDeep(reportDetails?.reportDetails);
        const config = clonedReportDetails.settings.numberChartTemplate.config || {}
        clonedReportDetails.settings.numberChartTemplate.config = { ...config, icon: value }
        updateReportDetails({ reportDetails: clonedReportDetails })
    }
    const handleNumberChartBackgroundImage = async (event) => {
        const { value } = event?.target
        const clonedReportDetails = _.cloneDeep(reportDetails?.reportDetails);
        const config = clonedReportDetails.settings.numberChartTemplate.config || {}
        clonedReportDetails.settings.numberChartTemplate.config = { ...config, backgroundImage: value }
        updateReportDetails({ reportDetails: clonedReportDetails })
    }

    const handleNumberChartTemplate5TitleDescription = async (event) => {
        const { value, name } = event?.target
        const clonedReportDetails = _.cloneDeep(reportDetails?.reportDetails);
        const config = clonedReportDetails.settings.numberChartTemplate.config || {}
        clonedReportDetails.settings.numberChartTemplate.config = { ...config, [name]: value }
        updateReportDetails({ reportDetails: clonedReportDetails })
    }

    const handleComparisionChartType = async (value) => {
        const clonedReportDetails = _.cloneDeep(reportDetails?.reportDetails);
        clonedReportDetails.comparisonChartType = !value;
        updateReportDetails({ reportDetails: clonedReportDetails })
    }

    const handleMobileColumns = (selectedOption) => {
        setMobileColumns(selectedOption)
        const clonedReportDetails = _.cloneDeep(reportDetails?.reportDetails);
        const columns = clonedReportDetails.settings.mobile.measureToDiplay || [{}]
        clonedReportDetails.settings.mobile.measureToDiplay = [...selectedOption]
        updateReportDetails({ reportDetails: clonedReportDetails })

    }

    const handleFillMissingDates = (e) => {
        const { checked } = e.target
        const clonedReportDetails = _.cloneDeep(reportDetails?.reportDetails);
        clonedReportDetails.settings.fillMissingDates = checked;
        updateReportDetails({ reportDetails: clonedReportDetails })
    }

    useEffect(() => {
        reportDetails.reportDetails.settings.fillMissingDates = fillMissingDates
        updateReportDetails({ reportDetails: reportDetails.reportDetails })
        //console.log('updateReportDetails')
    }, [fillMissingDates])

    let { formatVisual, settings, measures, chartType, linkedReports, reportName, tabName, carouselName, carouselDescription, linkedReportsViewCount, linkedReportsViewCountMobile, comparisonChartType = false, quickFilterList = [] } = reportDetails?.reportDetails ?? {}
    const isMultiAxisBarCombo = useMemo(() => chartType === 'multiAxisBarCombo', [chartType])
    return (
        <RootStyle>
            <div>
                <Box width="100%" height="100%" className={classes.reportSettingsSection}>
                    <Grid container alignItems="center">
                        <Grid item xs>
                            <Typography variant="h6" component="div" className="text-heading font-weight-600">Settings</Typography>
                        </Grid>
                    </Grid>
                    <Box className="report-new-charts">
                        <Accordion className="filter_accordian">
                            <AccordionSummary className="filter_accordian_summary " expandIcon={<DropDownIcon />} id="labelSettings">
                                <Typography variant='h6' className="font-weight-500 form_input_label">Title</Typography>
                            </AccordionSummary>

                            <AccordionDetails className="filter_accordian_details">
                                {/* <FormControlLabel className="text-plain" control={<Checkbox name="showTitle" checked={formatVisual?.titles?.showTitle} className="report_setting_checkbox" onChange={(e) => handleTitlesChange(e, 'checkbox')} />} label="Show Title" /> */}
                                <Typography className="report-form-label font-weight-500" variant="button" display="block" > Edit Title </Typography>
                                <TextField className="cm_rprt_setting_content report_form_ui_input border-0"
                                    type="search" size="small" placeholder="Title" name='title'
                                    onChange={(e) => handleTitlesChange(e, 'text')}
                                    value={formatVisual?.titles?.title}
                                />

                                {/* <FormControlLabel className="text-plain" sx={{ mt: 2 }} control={<Checkbox name="showSubTitle" checked={formatVisual?.titles?.showSubTitle} className="report_setting_checkbox" onChange={(e) => handleTitlesChange(e, 'checkbox')} />} label="Show Subtitle" /> */}
                                <Typography mt={1} className="report-form-label  font-weight-500" variant="button" display="block" > Edit Subtitle </Typography>
                                <TextField className="cm_rprt_setting_content report_form_ui_input border-0"
                                    type="search" size="small" placeholder="Sub Title" name='subTitle'
                                    onChange={(e) => handleTitlesChange(e, 'text')}
                                    value={formatVisual?.titles?.subTitle}
                                />
                            </AccordionDetails>
                        </Accordion>
                    </Box>


                    <Box className="report-new-charts">
                        <Accordion className="filter_accordian">
                            <AccordionSummary className="filter_accordian_summary " expandIcon={<DropDownIcon />} id="labelSettings">
                                <Typography variant='h6' className="font-weight-500 form_input_label">Label</Typography>
                            </AccordionSummary>

                            <AccordionDetails className="filter_accordian_details">
                                <Grid container className="title_popup_wrapper p-0" >
                                    {reportDetails?.reportDetails?.dimensions?.map(({ fieldName, displayName }, i) => {
                                        return (
                                            <Grid container item xs={12} key={i}>
                                                <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                                    <Typography variant="body2" sx={{ paddingBottom: '0.2rem' }}>{displayName ?? CamelToNormalString(fieldName.split('.')?.[1])} </Typography>
                                                    <Controls.Input className="report_form_ui_input" label=""
                                                        value={dimTitle[fieldName]}
                                                        onChange={e => handleDimTitleChange(e, fieldName)}
                                                    />
                                                </FormControl>

                                            </Grid>
                                        )
                                    })}
                                    {reportDetails?.reportDetails?.measures?.map(({ fieldName, displayName }, i) => {
                                        return (
                                            <Grid container item xs={12} key={i}>
                                                <FormControl variant="outlined" className={classes.formControl + ' width-100'} >
                                                    <Typography variant="body2" sx={{ paddingBottom: '0.2rem' }}>{displayName ?? CamelToNormalString(fieldName?.split('.')?.[1])} </Typography>
                                                    <Controls.Input className="report_form_ui_input" label=""
                                                        value={measTitle[fieldName]}
                                                        onChange={e => handleMeasTitleChange(e, fieldName)}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        )
                                    })}
                                    <Box sx={{ my: 1 }} >
                                        <Controls.Button sx={{ maxWidth: '100px' }} variant="contained" color="primary" size="small" className="report_form_ui_btn float-right form-input-btn" onClick={handleSaveTitle} text="Apply" />
                                    </Box>
                                </Grid>
                            </AccordionDetails>
                        </Accordion>
                    </Box>
                    {
                        (horizontalScrollChartTypes.includes(reportDetails?.reportDetails?.chartType))

                            ? <Box className={`report-new-charts ` + reportDetails?.reportDetails?.chartType}>
                                <Accordion className="filter_accordian"  >
                                    <AccordionSummary className="filter_accordian_summary " expandIcon={<DropDownIcon />} id="legendSettings">
                                        <Typography variant='h6' className="font-weight-500 form_input_label">Axis settings</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails className="filter_accordian_details pt-0">

                                        <Box>
                                            <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                                <Typography mt={2} variant="caption">X Axis title</Typography>
                                                <Controls.Input type="text" name="x-axis-title" placeholder='' className="report_form_ui_input" defaultValue={reportDetails?.reportDetails?.settings?.axisTitle?.x?.text || ''} onChange={async (e) => handleReportAxisSettings(e)} />
                                            </FormControl>

                                            <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                                <Typography mt={2} variant="caption">{`Y Axis title${isMultiAxisBarCombo ? ' (left)' : ''}`}</Typography>
                                                <Controls.Input type="text" name="y-axis-title" placeholder='' className="report_form_ui_input" defaultValue={reportDetails?.reportDetails?.settings?.axisTitle?.y?.text || ''} onChange={async (e) => handleReportAxisSettings(e)} />
                                            </FormControl>
                                            <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                                <Typography mt={2} variant="caption">{`Y axis interval${isMultiAxisBarCombo ? ' (left)' : ''}`}</Typography>
                                                <Controls.Input type="number" name="y-axis-interval" placeholder='' className="report_form_ui_input" defaultValue={reportDetails?.reportDetails?.settings?.axisSettings?.y?.left?.interval || 0} onChange={async (e) => handleReportAxisSettings(e)} />
                                            </FormControl>
                                            <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                                <Typography mt={2} variant="caption">{`Y axis max value${isMultiAxisBarCombo ? ' (left)' : ''}`}</Typography>
                                                <Controls.Input type="number" name="y-axis-max-value" placeholder='' className="report_form_ui_input" defaultValue={reportDetails?.reportDetails?.settings?.axisSettings?.y?.left?.max || 0} onChange={async (e) => handleReportAxisSettings(e)} />
                                            </FormControl>
                                            {
                                                (isMultiAxisBarCombo)
                                                    ? (
                                                        <>
                                                            <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                                                <Typography mt={2} variant="caption">Y Axis title (right)</Typography>
                                                                <Controls.Input type="text" name="y-axis-right-title" placeholder='' className="report_form_ui_input" defaultValue={reportDetails?.reportDetails?.settings?.axisTitle?.z?.text || ''} onChange={async (e) => handleReportAxisSettings(e)} />
                                                            </FormControl>
                                                            <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                                                <Typography mt={2} variant="caption">Y axis interval (right)</Typography>
                                                                <Controls.Input type="number" name="y-axis-right-interval" placeholder='' className="report_form_ui_input" defaultValue={reportDetails?.reportDetails?.settings?.axisSettings?.y?.right?.interval || 0} onChange={async (e) => handleReportAxisSettings(e)} />
                                                            </FormControl>
                                                            <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                                                <Typography mt={2} variant="caption">Y axis max value (right)</Typography>
                                                                <Controls.Input type="number" name="y-axis-right-max-value" placeholder='' className="report_form_ui_input" defaultValue={reportDetails?.reportDetails?.settings?.axisSettings?.y?.right?.max || 0} onChange={async (e) => handleReportAxisSettings(e)} />
                                                            </FormControl>
                                                        </>
                                                    ) : null
                                            }
                                        </Box>

                                    </AccordionDetails>
                                </Accordion>
                            </Box>
                            : null
                    }


                    <Box className="report-new-charts">
                        <Accordion className="filter_accordian" >
                            <AccordionSummary className="filter_accordian_summary " expandIcon={<DropDownIcon />} id="legendSettings">
                                <Typography variant='h6' className="font-weight-500 form_input_label">Legend</Typography>
                            </AccordionSummary>
                            <AccordionDetails className="filter_accordian_details">
                                <FormGroup>
                                    <FormControlLabel
                                        className="text-plain"
                                        control={<Switch onChange={handleLegendVisibility} checked={reportDetails?.reportDetails?.isLegendVisible} />}
                                        label="Legend Visibility" />

                                    <FormControl >
                                        <Typography variant="body2" sx={{ paddingBottom: '0.2rem' }}>Legend Position</Typography>
                                        <Select size='small' value={reportDetails?.reportDetails?.legendPosition || ""} onChange={e => handleLegendPosition(e)}
                                            className="report_form_ui_input_select" IconComponent={DropDownIcon} >
                                            <MenuItem className={classes.menuDropdownItem + " menu-item"} value={'top'}>Top</MenuItem>
                                            <MenuItem className={classes.menuDropdownItem + " menu-item"} value={'left'}>Left</MenuItem>
                                            <MenuItem className={classes.menuDropdownItem + " menu-item"} value={'right'}>Right</MenuItem>
                                            <MenuItem className={classes.menuDropdownItem + " menu-item"} value={'bottom'}>Bottom</MenuItem>
                                        </Select>
                                    </FormControl>
                                </FormGroup>
                            </AccordionDetails>
                        </Accordion>


                    </Box>


                    {/*<Box className="report-new-charts">
                        <Accordion className="filter_accordian" >
                            <AccordionSummary className="filter_accordian_summary " expandIcon={<DropDownIcon />} id="legendSettings">
                                <Typography variant='h6' className="font-weight-500 form_input_label">Remove Cache</Typography>
                            </AccordionSummary>
                            <AccordionDetails className="filter_accordian_details">
                                <FormGroup>
                                    <FormControlLabel
                                        className="text-plain"
                                        control={<Switch
                                            onChange={handleRenewQuery} checked={reportDetails?.reportDetails?.renewQuery} />}
                                        label="Remove Cache" />
                                </FormGroup>
                            </AccordionDetails>
                        </Accordion>
                                        </Box>*/}

                    <Box className="report-new-charts">
                        <Accordion className="filter_accordian" >
                            <AccordionSummary className="filter_accordian_summary " expandIcon={<DropDownIcon />} id="legendSettings">
                                <Typography variant='h6' className="font-weight-500 form_input_label">Text to shown on no data</Typography>
                            </AccordionSummary>
                            <AccordionDetails className="filter_accordian_details">
                                <Grid container item xs={12}>
                                    <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                        <Typography variant="body2" sx={{ paddingBottom: '0.2rem' }}>Text to shown on no data</Typography>
                                        <Controls.Input className="report_form_ui_input" label=""
                                            value={reportDetails?.reportDetails?.noDataText}
                                            onChange={handleNoDataText}
                                        />
                                    </FormControl>
                                </Grid>
                            </AccordionDetails>
                        </Accordion>
                    </Box>

                    <Box className="report-new-charts">
                        <Accordion className="filter_accordian" >
                            <AccordionSummary className="filter_accordian_summary " expandIcon={<DropDownIcon />} id="legendSettings">
                                <Typography variant='h6' className="font-weight-500 form_input_label">Web View Settings</Typography>
                            </AccordionSummary>
                            <AccordionDetails className="filter_accordian_details">

                                {horizontalScrollChartTypes.includes(chartType) || chartType === 'donut' || chartType === 'pie' || chartType === 'funnel' ?
                                    <>
                                        <Grid container item xs={12}>
                                            <FormGroup>
                                                <FormControlLabel
                                                    className="text-plain"
                                                    control={<Switch
                                                        name='showXaxisLabel'
                                                        onChange={(e) => handleSettings(e, 'web', 'checkbox')} checked={settings?.web?.showXaxisLabel} />}
                                                    label="Show Labels" />
                                            </FormGroup>
                                        </Grid>
                                        {
                                            (chartType !== 'funnel') ?
                                                <>
                                                    <Grid container item xs={12}>
                                                        <FormGroup>
                                                            <FormControlLabel
                                                                className="text-plain"
                                                                control={<Switch
                                                                    name='horizontalScroll'
                                                                    onChange={(e) => handleSettings(e, 'web', 'checkbox')} checked={settings?.web?.horizontalScroll} />}
                                                                label="Horizontal Scroller" />
                                                        </FormGroup>

                                                        {settings?.web?.horizontalScroll ? <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                                            <Typography variant="body2" sx={{ paddingBottom: '0.2rem' }}>Max Bars Count</Typography>
                                                            <Controls.Input className="report_form_ui_input"
                                                                value={settings?.web?.maxBarsCount}
                                                                name='maxBarsCount'
                                                                onChange={(e) => handleSettings(e, 'web', 'input')}
                                                                type="number"
                                                            />
                                                        </FormControl> : null}
                                                    </Grid>
                                                </>

                                                : null
                                        }

                                    </> : null}

                                {
                                    (chartType !== 'funnel') ?
                                        <>
                                            <Grid container item xs={12}>
                                                <FormGroup>
                                                    <FormControlLabel
                                                        className="text-plain"
                                                        control={<Switch
                                                            name='truncateLabel'
                                                            onChange={(e) => handleSettings(e, 'web', 'checkbox')} checked={settings?.web?.truncateLabel} />}
                                                        label="Truncate Label" />
                                                </FormGroup>

                                                {settings?.web?.truncateLabel ? <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                                    <Typography variant="body2" sx={{ paddingBottom: '0.2rem' }}>Max Characters Count</Typography>
                                                    <Controls.Input className="report_form_ui_input"
                                                        value={settings?.web?.maxLabelCharacters}
                                                        name='maxLabelCharacters'
                                                        onChange={(e) => handleSettings(e, 'web', 'input')}
                                                        type="number"
                                                    />
                                                </FormControl> : null}








                                            </Grid>
                                        </>

                                        : null
                                }


                                <Grid container item xs={12}>
                                    <FormGroup>
                                        <FormControlLabel
                                            className="text-plain"
                                            control={<Switch
                                                name='legendPagination'
                                                onChange={(e) => handleSettings(e, 'web', 'checkbox')} checked={settings?.web?.legendPagination} />}
                                            label="Legend Pagination" />
                                    </FormGroup>
                                    {settings?.web?.legendPagination ?
                                        <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                            <Typography variant="body2" sx={{ paddingBottom: '0.2rem' }}>Max Legends Count</Typography>
                                            <Controls.Input className="report_form_ui_input"
                                                value={settings?.web?.maxLegendsCount}
                                                name='maxLegendsCount'
                                                onChange={(e) => handleSettings(e, 'web', 'input')}
                                                type="number"
                                                InputProps={{ inputProps: { min: 1, max: 9 } }}
                                            />
                                        </FormControl> : null}
                                </Grid>

                                {
                                    (horizontalScrollChartTypes.includes(reportDetails?.reportDetails?.chartType)) ?
                                        <>
                                            <Grid container item xs={12}>

                                                <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                                    <Typography variant="body2" sx={{ paddingBottom: '0.2rem' }}>Chart Inner Height <small><i>(Min: 100px, Max: 500px)</i></small></Typography>
                                                    <Controls.Input className="report_form_ui_input"
                                                        value={settings?.web?.innerChartHeight ? settings?.web?.innerChartHeight : 250}
                                                        name='innerChartHeight'
                                                        onChange={(e) => handleSettings(e, 'web', 'input')}
                                                        type="number"
                                                        InputProps={{ inputProps: { min: 100, max: 500 } }}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </>

                                        : null
                                }

                                <FormGroup>
                                    <FormControlLabel
                                        className="text-plain"
                                        control={<Switch
                                            name='reportShowGridBackgroundColor'
                                            onChange={(e) => handleSettings(e, 'web', 'checkbox')} checked={!!settings?.web?.reportShowGridBackgroundColor} />}
                                        label="Show Grid Background Color" />
                                </FormGroup>
                                {
                                    settings?.web?.reportShowGridBackgroundColor
                                        ? <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                            <Typography variant="caption" className='re-new-settings-label'>Grid Background Color</Typography>
                                            <Controls.Input name='reportGridBgColor' type='color' placeholder='' className="report_form_ui_input p-0 "
                                                defaultValue={settings?.web?.reportGridBgColor ?? '#FFFFFF'}
                                                onChange={(e) => debounceFnBgColorChange(e, 'web')} />
                                        </FormControl>
                                        : null
                                }

                                <FormGroup>
                                    <FormControlLabel
                                        className="text-plain"
                                        control={<Switch
                                            name='reportShowBackgroundColor'
                                            onChange={(e) => handleSettings(e, 'web', 'checkbox')} checked={!!settings?.web?.reportShowBackgroundColor} />}
                                        label="Show Background Color" />
                                </FormGroup>

                                {
                                    settings?.web?.reportShowBackgroundColor
                                        ? <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                            <Typography variant="caption" className='re-new-settings-label'>Report Background Color</Typography>
                                            <Controls.Input name='reportBgColor' type='color' placeholder='' className="report_form_ui_input p-0 "
                                                defaultValue={settings?.web?.reportBgColor ?? '#FFFFFF'} onChange={(e) => debounceFnBgColorChange(e, 'web')} />
                                        </FormControl>
                                        : null
                                }

                                <FormGroup>
                                    <FormControlLabel
                                        className={"text-plain "}
                                        control={<Switch
                                            name='reportShowBorderColor'
                                            onChange={(e) => handleSettings(e, 'web', 'checkbox')} checked={!!settings?.web?.reportShowBorderColor} />}
                                        label="Show Border" />
                                </FormGroup>
                                {
                                    settings?.web?.reportShowBorderColor
                                        ? <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                            <Typography variant="caption" className='re-new-settings-label'>Report Border Color</Typography>
                                            <Controls.Input name='reportBorderColor' type='color' placeholder='' className="report_form_ui_input p-0 "
                                                defaultValue={settings?.web?.reportBorderColor ?? '#DEDEDE'} onChange={(e) => debounceFnBgColorChange(e, 'web')} />
                                        </FormControl>
                                        : null
                                }

                                {
                                    (reportDetails?.reportDetails?.linkedReportsViewType === 'CAROUSEL')
                                        ? <>

                                            <FormGroup>
                                                <FormControlLabel
                                                    className="text-plain"
                                                    control={<Switch
                                                        name='reportIsCarouselElevation'
                                                        onChange={(e) => handleSettings(e, 'web', 'checkbox')} checked={!!settings?.web?.reportIsCarouselElevation} />}
                                                    label="Show Carousel Elevation" />
                                            </FormGroup>

                                            {
                                                settings?.web?.reportIsCarouselElevation
                                                    ? <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                                        <Typography variant="caption" className='re-new-settings-label'>Carousel Elevation Color</Typography>
                                                        <Controls.Input name='reportCarouselElevationColor' type='color' placeholder='' className="report_form_ui_input p-0 "
                                                            defaultValue={settings?.web?.reporttCarouselElevationColor ?? '#DEDEDE'} onChange={(e) => debounceFnBgColorChange(e, 'web')} />
                                                    </FormControl>
                                                    : null
                                            }

                                            <FormGroup>
                                                <FormControlLabel
                                                    className="text-plain"
                                                    control={<Switch
                                                        name='reportIsCarouselCardElevation'
                                                        onChange={(e) => handleSettings(e, 'web', 'checkbox')} checked={!!settings?.web?.reportIsCarouselCardElevation} />}
                                                    label="Show Carousel Card Elevation" />
                                            </FormGroup>

                                            {
                                                settings?.web?.reportIsCarouselCardElevation
                                                    ? <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                                        <Typography variant="caption" className='re-new-settings-label'>Carousel Card Elevation Color</Typography>
                                                        <Controls.Input name='reportCarouselCardElevationColor' type='color' placeholder='' className="report_form_ui_input p-0 "
                                                            defaultValue={settings?.web?.reportCarouselCardElevationColor ?? '#DEDEDE'} onChange={(e) => debounceFnBgColorChange(e, 'web')} />
                                                    </FormControl>
                                                    : null
                                            }

                                            {/* <FormGroup>
                                                    <FormControlLabel
                                                        className="text-plain"
                                                        control={<Switch
                                                            name='reportIsCarouselCardTitle'
                                                            onChange={(e) => handleSettings(e, 'web', 'checkbox')} checked={settings?.web?.reportIsCarouselCardTitle} />}
                                                        label="Show Card Title" />
                                                </FormGroup> */}

                                            <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                                <Typography variant="caption" className='re-new-settings-label'>Carousel Card Spacing</Typography>
                                                <Select size='small' name='reportCarouselCardSpacing' value={reportDetails?.reportDetails?.settings?.web?.reportCarouselCardSpacing}
                                                    onChange={(e) => handleCarouselCardSpacing(e, 'web')} defaultValue={0}
                                                    className="report_form_ui_input_select pl-0" IconComponent={DropDownIcon} >
                                                    <MenuItem className={classes.menuDropdownItem + " menu-item menu-item-settings-format-option"} value={"0"}>0</MenuItem>
                                                    <MenuItem className={classes.menuDropdownItem + " menu-item menu-item-settings-format-option"} value={"5"}>5</MenuItem>
                                                    <MenuItem className={classes.menuDropdownItem + " menu-item menu-item-settings-format-option"} value={"10"}>10</MenuItem>
                                                    <MenuItem className={classes.menuDropdownItem + " menu-item menu-item-settings-format-option"} value={"15"}>15</MenuItem>
                                                    <MenuItem className={classes.menuDropdownItem + " menu-item menu-item-settings-format-option"} value={"20"}>20</MenuItem>
                                                    <MenuItem className={classes.menuDropdownItem + " menu-item menu-item-settings-format-option"} value={"25"}>25</MenuItem>
                                                    <MenuItem className={classes.menuDropdownItem + " menu-item menu-item-settings-format-option"} value={"30"}>30</MenuItem>
                                                </Select>
                                            </FormControl>

                                        </>
                                        : null
                                }

                                <FormGroup>
                                    <FormControlLabel
                                        className="text-plain"
                                        control={<Switch name='reportShowBorderForHeading' onChange={(e) => handleSettings(e, 'web', 'checkbox')} checked={settings?.web?.reportShowBorderForHeading} />}
                                        label="Enable Bottom Border For Heading" />
                                    <small><i>Visible in dashboard reports</i></small>
                                </FormGroup>


                            </AccordionDetails>
                        </Accordion>
                    </Box>



                    <Box className="report-new-charts">
                        <Accordion className="filter_accordian" >
                            <AccordionSummary className="filter_accordian_summary " expandIcon={<DropDownIcon />} id="legendSettings">
                                <Typography variant='h6' className="font-weight-500 form_input_label">Mobile View Settings</Typography>
                            </AccordionSummary>
                            <AccordionDetails className="filter_accordian_details">
                                {horizontalScrollChartTypes.includes(chartType) || chartType === 'donut' || chartType === 'pie' || chartType === 'funnel' ?
                                    <>
                                        <Grid container item xs={12}>
                                            <FormGroup>
                                                <FormControlLabel
                                                    className="text-plain"
                                                    control={<Switch
                                                        name='showXaxisLabel'
                                                        onChange={(e) => handleSettings(e, 'mobile', 'checkbox')} checked={settings?.mobile?.showXaxisLabel} />}
                                                    label="Show Labels" />
                                            </FormGroup>
                                        </Grid>
                                        {
                                            (chartType !== 'funnel') ?
                                                <>
                                                    <Grid container item xs={12}>
                                                        <FormGroup>
                                                            <FormControlLabel
                                                                className="text-plain"
                                                                control={<Switch
                                                                    name='horizontalScroll'
                                                                    onChange={(e) => handleSettings(e, 'mobile', 'checkbox')} checked={settings?.mobile?.horizontalScroll} />}
                                                                label="Horizontal Scroller" />
                                                        </FormGroup>
                                                        {settings?.mobile?.horizontalScroll ?
                                                            <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                                                <Typography variant="body2" sx={{ paddingBottom: '0.2rem' }}>Max Bars Count</Typography>
                                                                <Controls.Input className="report_form_ui_input"
                                                                    value={settings?.mobile?.maxBarsCount}
                                                                    name='maxBarsCount'
                                                                    onChange={(e) => handleSettings(e, 'mobile', 'input')}
                                                                    type="number"
                                                                />
                                                            </FormControl> : null}
                                                    </Grid>
                                                </>

                                                : null

                                        }

                                    </> : null}
                                {
                                    (chartType !== 'funnel') ?
                                        <>
                                            <Grid container item xs={12}>
                                                <FormGroup>
                                                    <FormControlLabel
                                                        className="text-plain"
                                                        control={<Switch
                                                            name='truncateLabel'
                                                            onChange={(e) => handleSettings(e, 'mobile', 'checkbox')} checked={settings?.mobile?.truncateLabel} />}
                                                        label="Truncate Label" />
                                                </FormGroup>

                                                {settings?.mobile?.truncateLabel ? <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                                    <Typography variant="body2" sx={{ paddingBottom: '0.2rem' }}>Max Characters Count</Typography>
                                                    <Controls.Input className="report_form_ui_input"
                                                        value={settings?.mobile?.maxLabelCharacters}
                                                        name='maxLabelCharacters'
                                                        onChange={(e) => handleSettings(e, 'mobile', 'input')}
                                                        type="number"
                                                    />
                                                </FormControl> : null}

                                            </Grid>
                                        </>
                                        : null
                                }

                                {(chartType === 'table') ?

                                    <FormControl variant="outlined" className={classes.formControl + ' width-100'} >
                                        <Typography variant="body2" sx={{ paddingBottom: '0.2rem' }}>Fields To Render</Typography>
                                        <ReactSelect
                                            classNamePrefix="select"
                                            isMulti={true}
                                            options={formattedOptions}
                                            placeholder="Select Fields"
                                            menuPlacement='auto'
                                            getOptionLabel={(option) => option.label}
                                            getOptionValue={(option) => option.value}
                                            value={mobileColumns}
                                            onChange={handleMobileColumns}
                                        />
                                    </FormControl>
                                    :
                                    null

                                }


                                <Grid container item xs={12}>
                                    <FormGroup>
                                        <FormControlLabel
                                            className="text-plain"
                                            control={<Switch
                                                name='legendPagination'
                                                onChange={(e) => handleSettings(e, 'mobile', 'checkbox')} checked={settings?.mobile?.legendPagination} />}
                                            label="Legend Pagination" />
                                    </FormGroup>
                                    {settings?.mobile?.legendPagination ? <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                        <Typography variant="body2" sx={{ paddingBottom: '0.2rem' }}>Max Legends Count</Typography>
                                        <Controls.Input className="report_form_ui_input"
                                            value={settings?.mobile?.maxLegendsCount}
                                            name='maxLegendsCount'
                                            onChange={(e) => handleSettings(e, 'mobile', 'input')}
                                            type="number"
                                            InputProps={{ inputProps: { min: 1, max: 9 } }}
                                        />
                                    </FormControl> : null}
                                </Grid>

                                {
                                    (horizontalScrollChartTypes.includes(reportDetails?.reportDetails?.chartType)) ?
                                        <>
                                            <Grid container item xs={12}>

                                                <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                                    <Typography variant="body2" sx={{ paddingBottom: '0.2rem' }}>Chart Inner Height <small><i>(Min: 100px, Max: 500px)</i></small></Typography>
                                                    <Controls.Input className="report_form_ui_input"
                                                        value={settings?.mobile?.innerChartHeight ? settings?.mobile?.innerChartHeight : 250}
                                                        name='innerChartHeight'
                                                        onChange={(e) => handleSettings(e, 'web', 'input')}
                                                        type="number"
                                                        InputProps={{ inputProps: { min: 100, max: 500 } }}

                                                    />
                                                </FormControl>
                                            </Grid>
                                        </>

                                        : null
                                }
                                <FormGroup>
                                    <FormControlLabel
                                        className="text-plain"
                                        control={<Switch
                                            name='reportShowGridBackgroundColor'
                                            onChange={(e) => handleSettings(e, 'mobile', 'checkbox')} checked={settings?.mobile?.reportShowGridBackgroundColor} />}
                                        label="Show Grid Background Color" />
                                </FormGroup>

                                {
                                    settings?.mobile?.reportShowGridBackgroundColor
                                        ? <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                            <Typography variant="caption" className='re-new-settings-label'>Grid Background Color</Typography>
                                            <Controls.Input name='reportGridBgColor' type='color' placeholder='' className="report_form_ui_input p-0 " defaultValue={settings?.mobile?.reportGridBgColor ?? '#FFFFFF'} onChange={(e) => debounceFnBgColorChange(e, 'mobile')} />
                                        </FormControl>
                                        : null
                                }

                                <FormGroup>
                                    <FormControlLabel
                                        className="text-plain"
                                        control={<Switch
                                            name='reportShowBackgroundColor'
                                            onChange={(e) => handleSettings(e, 'mobile', 'checkbox')} checked={settings?.mobile?.reportShowBackgroundColor} />}
                                        label="Show Background Color" />
                                </FormGroup>

                                {
                                    settings?.mobile?.reportShowBackgroundColor
                                        ? <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                            <Typography variant="caption" className='re-new-settings-label'>Report Background Color</Typography>
                                            <Controls.Input name='reportBgColor' type='color' placeholder='' className="report_form_ui_input p-0 " defaultValue={settings?.mobile?.reportBgColor ?? '#FFFFFF'}
                                                onChange={(e) => debounceFnBgColorChange(e, 'mobile')} />
                                        </FormControl>
                                        : null
                                }



                                <FormGroup>
                                    <FormControlLabel
                                        className="text-plain"
                                        control={<Switch
                                            name='reportShowBorderColor'
                                            onChange={(e) => handleSettings(e, 'mobile', 'checkbox')} checked={settings?.mobile?.reportShowBorderColor} />}
                                        label="Show Border" />
                                </FormGroup>
                                {
                                    settings?.mobile?.reportShowBorderColor
                                        ? <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                            <Typography variant="caption" className='re-new-settings-label'>Report Border Color</Typography>
                                            <Controls.Input name='reportBorderColor' type='color' placeholder='' className="report_form_ui_input p-0 " defaultValue={settings?.mobile?.reportBorderColor ?? '#FFFFFF'}
                                                onChange={(e) => debounceFnBgColorChange(e, 'mobile')} />
                                        </FormControl>
                                        : null
                                }


                                {
                                    (reportDetails?.reportDetails?.linkedReportsViewType === 'CAROUSEL')
                                        ? <>

                                            <FormGroup>
                                                <FormControlLabel
                                                    className="text-plain"
                                                    control={<Switch
                                                        name='reportIsCarouselElevation'
                                                        onChange={(e) => handleSettings(e, 'mobile', 'checkbox')} checked={!!settings?.mobile?.reportIsCarouselElevation} />}
                                                    label="Show Carousel Elevation" />
                                            </FormGroup>

                                            {
                                                settings?.mobile?.reportIsCarouselElevation
                                                    ? <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                                        <Typography variant="caption" className='re-new-settings-label'>Carousel Elevation Color</Typography>
                                                        <Controls.Input name='reportCarouselElevationColor' type='color' placeholder='' className="report_form_ui_input p-0 "
                                                            defaultValue={settings?.mobile?.reportCarouselElevationColor ?? '#DEDEDE'} onChange={(e) => debounceFnBgColorChange(e, 'mobile')} />
                                                    </FormControl>
                                                    : null
                                            }

                                            <FormGroup>
                                                <FormControlLabel
                                                    className="text-plain"
                                                    control={<Switch
                                                        name='reportIsCarouselCardElevation'
                                                        onChange={(e) => handleSettings(e, 'mobile', 'checkbox')} checked={settings?.mobile?.reportIsCarouselCardElevation} />}
                                                    label="Show Carousel Card Elevation" />
                                            </FormGroup>

                                            {
                                                settings?.mobile?.reportIsCarouselCardElevation
                                                    ? <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                                        <Typography variant="caption" className='re-new-settings-label'>Carousel Card Elevation Color</Typography>
                                                        <Controls.Input name='reportCarouselCardElevationColor' type='color' placeholder='' className="report_form_ui_input p-0 "
                                                            defaultValue={settings?.mobile?.reportCarouselCardElevationColor ?? '#DEDEDE'} onChange={(e) => debounceFnBgColorChange(e, 'mobile')} />
                                                    </FormControl>
                                                    : null
                                            }

                                            {/* <FormGroup>
                                                    <FormControlLabel
                                                        className="text-plain"
                                                        control={<Switch
                                                            name='reportIsCarouselCardTitle'
                                                            onChange={(e) => handleSettings(e, 'mobile', 'checkbox')} checked={settings?.mobile?.reportIsCarouselCardTitle} />}
                                                        label="Show Card Title" />
                                                </FormGroup> */}

                                            <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                                <Typography variant="caption" className='re-new-settings-label'>Carousel Card Spacing</Typography>
                                                <Select size='small' name='reportCarouselCardSpacing' value={reportDetails?.reportDetails?.settings?.mobile?.reportCarouselCardSpacing}
                                                    onChange={(e) => handleCarouselCardSpacing(e, 'mobile')} defaultValue={0}
                                                    className="report_form_ui_input_select pl-0" IconComponent={DropDownIcon} >
                                                    <MenuItem className={classes.menuDropdownItem + " menu-item menu-item-settings-format-option"} value={"0"}>0</MenuItem>
                                                    <MenuItem className={classes.menuDropdownItem + " menu-item menu-item-settings-format-option"} value={"5"}>5</MenuItem>
                                                    <MenuItem className={classes.menuDropdownItem + " menu-item menu-item-settings-format-option"} value={"10"}>10</MenuItem>
                                                    <MenuItem className={classes.menuDropdownItem + " menu-item menu-item-settings-format-option"} value={"15"}>15</MenuItem>
                                                    <MenuItem className={classes.menuDropdownItem + " menu-item menu-item-settings-format-option"} value={"20"}>20</MenuItem>
                                                    <MenuItem className={classes.menuDropdownItem + " menu-item menu-item-settings-format-option"} value={"25"}>25</MenuItem>
                                                    <MenuItem className={classes.menuDropdownItem + " menu-item menu-item-settings-format-option"} value={"30"}>30</MenuItem>
                                                </Select>
                                            </FormControl>

                                        </>
                                        : null
                                }

                                <FormGroup>
                                    <FormControlLabel
                                        className="text-plain"
                                        control={<Switch name='reportShowBorderForHeading' onChange={(e) => handleSettings(e, 'mobile', 'checkbox')} checked={settings?.mobile?.reportShowBorderForHeading} />}
                                        label="Enable Bottom Border For Heading" />
                                    <small><i>Visible in dashboard reports</i></small>
                                </FormGroup>

                            </AccordionDetails>
                        </Accordion>
                    </Box>

                    <Box className="report-new-charts">
                        <Accordion className="filter_accordian" >
                            <AccordionSummary className="filter_accordian_summary " expandIcon={<DropDownIcon />} id="legendSettings">
                                <Typography variant='h6' className="font-weight-500 form_input_label">Other Settings</Typography>
                            </AccordionSummary>
                            <AccordionDetails className="filter_accordian_details">

                                <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                    <Typography variant="caption" className='re-new-settings-label'>Ungrouped Query</Typography>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                name="comparisionChartType"
                                                checked={
                                                    settings?.fillMissingDates === null || settings?.fillMissingDates === undefined
                                                        ? false
                                                        : settings?.fillMissingDates
                                                }
                                                onChange={handleFillMissingDates}
                                            />
                                        }
                                        label="Fill Missing Dates"
                                    />
                                </FormControl>

                                {
                                    !quickFilterList?.length
                                        ? (
                                            <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                                <Typography variant="caption" className='re-new-settings-label'>Comparison Chart</Typography>
                                                <FormControlLabel
                                                    control={
                                                        <Switch name="comparisionChartType" checked={comparisonChartType} onChange={() => handleComparisionChartType(comparisonChartType)} />
                                                    }
                                                    label="Show Comparison Chart"
                                                />
                                            </FormControl>
                                        )
                                        : null
                                }

                                {!tableChartTypes.includes(chartType) ? <Grid container item xs={12}>
                                    <FormGroup>
                                        <FormControlLabel
                                            className="text-plain"
                                            control={<Switch name='showTogleToTable' onChange={(e) => handleSettings(e, null, 'checkbox')} checked={settings?.showTogleToTable} />}
                                            label="Enable Toggle To Table" />
                                    </FormGroup>
                                </Grid> : null}


                                {/* <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                    <Typography variant="caption" className='re-new-settings-label'>Card Color</Typography>
                                    <Controls.Input name='colorCode' type='color' placeholder='Enter Color Code' className="report_form_ui_input " defaultValue={settings?.colorCode} onChange={(e) => debounceFnColorChange(e)} />
                                </FormControl> */}

                                <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                    <Typography onClick={() => setOtherSettingsRowsPerPageModal(true)} className='re-settings-accordian-link' variant="p">Set No of Rows per page</Typography>
                                </FormControl>

                                <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                    <Typography onClick={() => setOtherSettingsAlignmentModal(true)} className='re-settings-accordian-link' variant="p">Set Alignment</Typography>
                                </FormControl>


                                {horizontalScrollChartTypes.includes(chartType) ?
                                    <Grid container item xs={12}>
                                        <FormGroup>
                                            <FormControlLabel
                                                className="text-plain"
                                                control={<Switch name='showMultiColoredBar' onChange={(e) => handleSettings(e, null, 'checkbox')} checked={settings?.showMultiColoredBar} />}
                                                label="Show Multicolor Bar Charts" />
                                        </FormGroup>
                                    </Grid> : null}

                                {chartType === 'donut' ? <Grid container item xs={12}>
                                    <FormGroup>
                                        <FormControlLabel
                                            className="text-plain"
                                            control={<Switch name='showDonutValue' onChange={(e) => handleSettings(e, null, 'checkbox')} checked={settings?.showDonutValue} />}
                                            label="Show Donut Chart Total Count" />
                                    </FormGroup>
                                </Grid> : null}

                                {horizontalScrollChartTypes.includes(chartType) || chartType === 'histogram' || chartType === 'treemap' ?
                                    <Grid container item xs={12}>
                                        <Grid item xs={12}>
                                            <FormGroup>
                                                <FormControlLabel
                                                    className="text-plain"
                                                    control={<Switch name='showBarValueOnTop' onChange={(e) => handleSettings(e, null, 'checkbox')} checked={settings?.showBarValueOnTop} />}
                                                    label="Show Bar Value" />
                                            </FormGroup>
                                        </Grid>

                                        {settings?.showBarValueOnTop ? <Grid item xs={12}>
                                            <FormControl className="full_width" >
                                                <Typography variant="body2" sx={{ paddingBottom: '0.2rem' }}>Value Position</Typography>
                                                <Select size='small' value={settings?.barValuePosition || ""} onChange={(e) => handleSettings(e, null, 'input')}
                                                    className='sm-select' name='barValuePosition'>
                                                    <MenuItem className={classes.menuDropdownItem + " menu-item"} value={'top'}>Top</MenuItem>
                                                    <MenuItem className={classes.menuDropdownItem + " menu-item"} value={'left'}>Left</MenuItem>
                                                    <MenuItem className={classes.menuDropdownItem + " menu-item"} value={'right'}>Right</MenuItem>
                                                    <MenuItem className={classes.menuDropdownItem + " menu-item"} value={'bottom'}>Bottom</MenuItem>
                                                    <MenuItem className={classes.menuDropdownItem + " menu-item"} value={'inside'}>Inside</MenuItem>
                                                    <MenuItem className={classes.menuDropdownItem + " menu-item"} value={'insideTop'}>Inside Top</MenuItem>
                                                    <MenuItem className={classes.menuDropdownItem + " menu-item"} value={'insideBottom'}>Inside Bottom</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid> : null}
                                    </Grid> : null}

                                <Box className='re-new-settings-format'>
                                    <Typography className='re-new-settings-input-label'>Format</Typography>
                                    <Box className='re-new-settings-format-select' onClick={() => setFormatDropdownStatus(formatDropdownStatus ? false : true)}>
                                        <Typography className='re-new-settings-format-select-placeholder'>{formatValue ?? 'Select here'}</Typography>
                                        <DropDownIcon className={`re-new-settings-format-icon ` + (formatDropdownStatus ? `open` : ``)} />
                                    </Box>
                                    <Box className={`re-new-settings-format-options ` + (formatDropdownStatus ? `show` : ``)}>
                                        <Typography className={`re-new-settings-format-option-item ` + (settings?.dataFormat?.format === 'number' ? 'has-selected' : '')} onClick={e => handleDataFormat({ target: { value: 'number' } })}>Number</Typography>
                                        <Typography className={`re-new-settings-format-option-item ` + (settings?.dataFormat?.format === 'percentage' ? 'has-selected' : '')} onClick={e => handleDataFormat({ target: { value: 'percentage' } })}>Percentage</Typography>
                                        <Select size='small' value={settings?.dataFormat?.timeFormat} onChange={e => handleDataFormat(e, 'time')} className='re-new-settings-format-option-select' name=''
                                            displayEmpty renderValue={value => !value ? 'Time' : value}
                                            inputProps={{ 'aria-label': 'Without label' }}
                                            placeholder='' IconComponent={DropDownIcon}>
                                            <MenuItem className={classes.menuDropdownItem + " menu-item menu-item-settings-format-option"} value={'seconds'}>Seconds</MenuItem>
                                            <MenuItem className={classes.menuDropdownItem + " menu-item menu-item-settings-format-option"} value={'minutes'}>Minutes</MenuItem>
                                            <MenuItem className={classes.menuDropdownItem + " menu-item menu-item-settings-format-option"} value={'hours'}>Hours</MenuItem>
                                        </Select>
                                        <Select size='small' value={settings?.dataFormat?.currencyFormat} onChange={e => handleDataFormat(e, 'currency')}
                                            className='re-new-settings-format-option-select' name=''
                                            displayEmpty
                                            renderValue={value => !value ? 'Currency' : value}
                                            inputProps={{ 'aria-label': 'Without label' }}
                                            placeholder='Currency' IconComponent={DropDownIcon}>
                                            {
                                                CURRENCIES && CURRENCIES.length && CURRENCIES?.map((symbol ) => (
                                                    <MenuItem key={symbol} className={classes.menuDropdownItem + " menu-item menu-item-settings-format-option"} value={symbol}>{symbol}</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </Box>
                                </Box>

                                {
                                    (chartType === 'bar' || chartType === 'line' || chartType === 'area' || chartType === 'scatter' || chartType === 'clusteredBarCombo' || chartType === 'stackedBarCombo' || chartType === 'multiAxisBarCombo' || chartType === 'verticalStackedBarChart100') ?
                                        <>
                                            <Grid container item xs={12}>
                                                <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                                    <Typography variant="body2" sx={{ paddingBottom: '0.2rem' }}>Label Rotation</Typography>
                                                    <Controls.Input className="report_form_ui_input"
                                                        value={settings?.xAxisLabelDegree}
                                                        name='xAxisLabelDegree'
                                                        onChange={(e) => handleSettings(e, null, 'input')}
                                                        type="number"
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </>

                                        : null
                                }



                            </AccordionDetails>
                        </Accordion>
                    </Box>

                    <Box className="report-new-charts">
                        <Accordion className="filter_accordian" onChange={handleLinkReportAccordion} >
                            <AccordionSummary className="filter_accordian_summary " expandIcon={<DropDownIcon />} id="legendSettings">
                                <Typography variant='h6' className="font-weight-500 form_input_label">Link Reports</Typography>
                            </AccordionSummary>
                            <AccordionDetails className="filter_accordian_details">
                                <Box>
                                    <ReactSelect
                                        classNamePrefix="select"
                                        isMulti
                                        options={linkableReports}
                                        menuPlacement='auto'
                                        getOptionLabel={(option) => option.reportName}
                                        getOptionValue={(option) => option._id}
                                        value={linkedReports}
                                        onChange={handleLinkReports}
                                    />
                                </Box>
                                {
                                    linkedReports?.length
                                        ? <Box mt={2}>
                                            <Select size='small' name='linkedReportsViewType' value={reportDetails?.reportDetails?.linkedReportsViewType} onChange={handleLinkedReportView}
                                                className="report_form_ui_input_select pl-0" IconComponent={DropDownIcon} >
                                                <MenuItem className={classes.menuDropdownItem + " menu-item menu-item-settings-format-option"} value={"TAB"}>Tabs View</MenuItem>
                                                <MenuItem className={classes.menuDropdownItem + " menu-item menu-item-settings-format-option"} value={"CAROUSEL"}>Carousel View</MenuItem>
                                            </Select>
                                            {
                                                (reportDetails?.reportDetails?.linkedReportsViewType === 'CAROUSEL')
                                                    ? <>
                                                        <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                                            <Typography mt={2} variant="caption">Carousel Card Count</Typography>
                                                            <Controls.Input name="linkedReportsViewCount" placeholder='Enter Card Count' className="report_form_ui_input" value={linkedReportsViewCount} onChange={handleLinkedReportView} />
                                                        </FormControl>

                                                        <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                                            <Typography mt={2} variant="caption">Carousel Card Count Mobile</Typography>
                                                            <Controls.Input type="number" name="linkedReportsViewCountMobile" placeholder='Enter Card Count' className="report_form_ui_input" value={linkedReportsViewCountMobile} onChange={handleLinkedReportView} />
                                                        </FormControl>

                                                        <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                                            <Typography mt={2} variant="caption">{`Carousel Title For:  ${reportName}`}</Typography>
                                                            <Controls.Input placeholder='Carousel Title' className="report_form_ui_input" defaultValue={carouselName} onChange={e => handleReportCarouselName(e)} />
                                                        </FormControl>
                                                        <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                                            <Typography mt={2} variant="caption">{`Carousel Description For:  ${reportName}`}</Typography>
                                                            <Controls.Input placeholder='Carousel Desc' className="report_form_ui_input" defaultValue={carouselDescription} onChange={e => handleReportCarouselDescription(e)} />
                                                        </FormControl>

                                                        {linkedReports?.map((reportObj, i) => {
                                                            return (
                                                                <div key={`${reportObj?._id}-${i}-carousel-title-description`}>
                                                                    <FormControl key={`${reportObj._id}-carouselName`} variant="outlined" className={classes.formControl + ' width-100'}>
                                                                        <Typography mt={2} variant="caption">{`Carousel Title For:  ${reportObj?.reportName}`}</Typography>
                                                                        <Controls.Input placeholder='Carousel Title' className="report_form_ui_input" defaultValue={reportObj?.carouselName} onChange={(e) => handleReportCarouselName(e, reportObj?._id)} />
                                                                    </FormControl>
                                                                    <FormControl key={`${reportObj._id}-carouselDescription`} variant="outlined" className={classes.formControl + ' width-100'}>
                                                                        <Typography mt={2} variant="caption">{`Carousel Description For:  ${reportObj?.reportName}`}</Typography>
                                                                        <Controls.Input placeholder='Carousel Desc' className="report_form_ui_input" defaultValue={reportObj?.carouselDescription} onChange={(e) => handleReportCarouselDescription(e, reportObj?._id)} />
                                                                    </FormControl>
                                                                </div>
                                                            )
                                                        })}

                                                    </>

                                                    : null
                                            }

                                        </Box> : null}

                                {
                                    (reportDetails?.reportDetails?.linkedReportsViewType === 'TAB')
                                        ? <>

                                            <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                                <Typography mt={2} variant="caption">{`Tab Title For:  ${reportName}`}</Typography>
                                                <Controls.Input placeholder='Enter Tab Title' className="report_form_ui_input" value={tabName} onChange={handleReportTabName} />
                                            </FormControl>

                                            {linkedReports?.map((reportObj, i) => {
                                                return (
                                                    <FormControl key={i} variant="outlined" className={classes.formControl + ' width-100'}>
                                                        <Typography mt={2} variant="caption">{`Tab Title For:  ${reportObj?.reportName}`}</Typography>
                                                        <Controls.Input placeholder='Enter Tab Title' className="report_form_ui_input" value={reportObj?.tabName} onChange={(e) => handleLinkedReportTabName(e, i)} />
                                                    </FormControl>
                                                )
                                            })}
                                        </>

                                        : null
                                }



                            </AccordionDetails>
                        </Accordion>
                    </Box>
                    {
                        chartType === 'number'
                            ? (
                                <Box className="report-new-charts">
                                    <Accordion className="filter_accordian" >
                                        <AccordionSummary className="filter_accordian_summary " expandIcon={<DropDownIcon />} id="legendSettings">
                                            <Typography variant='h6' className="font-weight-500 form_input_label">NumberChart Templates</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails className="filter_accordian_details">
                                            <FormGroup>
                                                <FormControl>
                                                    <Typography variant="body2" sx={{ paddingBottom: '0.2rem' }}>Select template</Typography>
                                                    <Select
                                                        size='small'
                                                        value={settings?.numberChartTemplate?.template || ""}
                                                        className="report_form_ui_input_select"
                                                        IconComponent={DropDownIcon}
                                                    >
                                                        {
                                                            NumberGraphTemplates.map((template, index) => {
                                                                return (
                                                                    <MenuItem onClick={() => handleNumberChartTemplate(template.value, index)} className={classes.menuDropdownItem + " menu-item"} key={index} value={template.value}>{template.label}</MenuItem>
                                                                )
                                                            })
                                                        }
                                                    </Select>
                                                </FormControl>
                                                {/* color */}
                                                {
                                                    (settings?.numberChartTemplate?.template && numberChartTemplateSeletedIndex && NumberGraphTemplates[numberChartTemplateSeletedIndex]?.config?.color)
                                                        ? (
                                                            <FormControl>
                                                                <Typography variant="body2" sx={{ paddingBottom: '0.2rem' }}> Color </Typography>
                                                                <TextField className="cm_rprt_setting_content report_form_ui_input border-0"
                                                                    type="color" size="small" placeholder="color" name='color'
                                                                    onChange={handleNumberChartTemplateColor}
                                                                    value={settings?.numberChartTemplate?.config?.color || ""}
                                                                />
                                                            </FormControl>

                                                        )
                                                        : null
                                                }
                                                {/* icon */}
                                                {
                                                    (settings?.numberChartTemplate?.template && numberChartTemplateSeletedIndex && NumberGraphTemplates[numberChartTemplateSeletedIndex]?.config?.icon)
                                                        ? (
                                                            <FormControl>
                                                                <Typography variant="body2" sx={{ paddingBottom: '0.2rem' }}> Icon </Typography>
                                                                <Select
                                                                    size='small'
                                                                    value={settings?.numberChartTemplate?.config?.icon || ""}
                                                                    onChange={handleNumberChartIcon}
                                                                    className="report_form_ui_input_select"
                                                                    IconComponent={DropDownIcon}
                                                                >
                                                                    {
                                                                        iconList.map((icon, index) => {
                                                                            return (
                                                                                <MenuItem sx={{ background: "lightGray" }} className={classes.menuDropdownItem + " menu-item"} key={index} value={icon.iconUrl}>{
                                                                                    <img src={icon.iconUrl} alt={icon.iconName}
                                                                                        style={{
                                                                                            width: '20px',
                                                                                            height: '20px',
                                                                                            overflow: 'hidden',
                                                                                            padding: '1px',
                                                                                            color: 'lightor'
                                                                                        }} /> || icon.iconName
                                                                                }</MenuItem>
                                                                            )
                                                                        })
                                                                    }
                                                                </Select>
                                                            </FormControl>
                                                        )
                                                        : null
                                                }
                                                {/* background image */}
                                                {
                                                    (settings?.numberChartTemplate?.template && numberChartTemplateSeletedIndex && NumberGraphTemplates[numberChartTemplateSeletedIndex]?.config?.background)
                                                        ? (
                                                            <FormControl>
                                                                <Typography variant="body2" sx={{ paddingBottom: '0.2rem' }}> Background Image </Typography>
                                                                <Select
                                                                    size='small'
                                                                    value={settings?.numberChartTemplate?.config?.backgroundImage || ""}
                                                                    onChange={handleNumberChartBackgroundImage}
                                                                    className="report_form_ui_input_select"
                                                                    IconComponent={DropDownIcon}
                                                                >
                                                                    <MenuItem
                                                                        className={classes.menuDropdownItem + " menu-item"} value="image1">
                                                                        image1
                                                                    </MenuItem>
                                                                    <MenuItem
                                                                        className={classes.menuDropdownItem + " menu-item"} value="image2">
                                                                        image2
                                                                    </MenuItem>
                                                                </Select>
                                                            </FormControl>
                                                        )
                                                        : null
                                                }
                                                {/* rate change */}
                                                {
                                                    <>

                                                        <FormControlLabel
                                                            className="text-plain"
                                                            control={<Switch name='showTogleToTable' onChange={handleShowRateChange} checked={settings?.rateChangeProps?.showRateChange} />}
                                                            label="Show Rate of Change" />


                                                        <Box className={`re-new-settings-rateChange-options ` + (settings?.rateChangeProps?.showRateChange ? `show` : ``)}>
                                                            <Typography className='re-new-settings-input-label'>Date Field</Typography>

                                                            <Select value={settings?.rateChangeProps?.dateField?.split('.')[1] || ''} onChange={e => handleRateDateField(e)} className='re-new-settings-format-option-select-date-field' name=''
                                                                displayEmpty
                                                                renderValue={value => !value ? 'Date Field' : value}
                                                                inputProps={{ 'aria-label': 'Without label' }}
                                                                placeholder='Currency' IconComponent={DropDownIcon}>
                                                                {
                                                                    dateFieldList && dateFieldList?.length ? (dateFieldList?.map((field, i) => (
                                                                        <MenuItem key={i} className={classes.menuDropdownItem + " menu-item menu-item-settings-format-option"} value={field?.name}>{field?.name}</MenuItem>
                                                                    ))) : null
                                                                }
                                                            </Select>
                                                            <Box className='re-new-settings-format'>
                                                                <Typography className='re-new-settings-input-label'>Periodicity</Typography>
                                                                <Box className='re-new-settings-format-select' onClick={() => setPeriodicityDropdownStatus(periodicityDropdownStatus ? false : true)}>
                                                                    <Typography className='re-new-settings-format-select-placeholder'> {settings?.rateChangeProps?.periodicity ||
                                                                        settings?.rateChangeProps?.customVal || `Select here`}</Typography>
                                                                    <DropDownIcon className={`re-new-settings-format-icon ` + (periodicityDropdownStatus ? `open` : ``)} />
                                                                </Box>
                                                                <Box className={`re-new-settings-format-options ` + (periodicityDropdownStatus ? `show` : ``)}>

                                                                    <Typography className='re-new-settings-format-option-item' onClick={e => handleRatePeriod('daily')} >Daily</Typography>
                                                                    <Typography className='re-new-settings-format-option-item' onClick={e => handleRatePeriod('weekly')} >Weekly</Typography>
                                                                    <Typography className='re-new-settings-format-option-item' onClick={e => handleRatePeriod('monthly')}>Monthly</Typography>
                                                                    <Typography className='re-new-settings-format-option-item' onClick={e => handleRatePeriod('quarterly')}>Quarterly</Typography>
                                                                    <Typography className='re-new-settings-format-option-item' onClick={e => handleRatePeriod('yearly')}>Yearly</Typography>
                                                                    <Box className='re-custom-select re-settings-select-filter' onClick={() => setPeriodicityCustomStatus(periodicityCustomStatus ? false : true)}>
                                                                        <Typography className='re-custom-select-placeholder'>Custom</Typography>
                                                                        <DropDownIcon className={`re-custom-select-icon ` + (periodicityCustomStatus ? `open` : ``)} />
                                                                    </Box>
                                                                    <Box className={`re-custom-select-options-plain ` + (periodicityCustomStatus ? `show` : ``)}>
                                                                        <TextField className='re-custom-select-input' type="text"
                                                                            value={customPeriodLabel}
                                                                            placeholder="Custom Label"
                                                                            onChange={e => setCustomPeriodLabel(e.target.value)}

                                                                        />
                                                                        <TextField className='re-custom-select-input' type="number"
                                                                            value={customPeriod}
                                                                            onChange={e => setCustomPeriod(e?.target?.value)}
                                                                        />
                                                                        <Button variant='outlined' style={{ marginTop: '5px' }}
                                                                            onClick={e => handleRatePeriod('custom')}>Apply</Button>
                                                                    </Box>

                                                                </Box>
                                                                <FormControlLabel
                                                                className="text-plain"
                                                                control={<Switch name='showTogleToTable' onChange={handleShowYearOnYearChange} checked={settings.rateChangeProps && settings?.rateChangeProps?.showYearOnYearChange} />}
                                                                label="Show Year on Year Change" />
                                                            </Box>

                                                        </Box>
                                                    </>
                                                }
                                                {/* template 5 title and description */}
                                                {
                                                    (
                                                        NumberGraphTemplates[numberChartTemplateSeletedIndex]?.config?.title
                                                        || NumberGraphTemplates[numberChartTemplateSeletedIndex]?.config?.description
                                                    )
                                                        ? (
                                                            <>
                                                                <FormControl>
                                                                    <Typography variant="body2" sx={{ paddingBottom: '0.2rem' }}> Title </Typography>
                                                                    <TextField
                                                                        className='re-new-settings-input'
                                                                        type="text"
                                                                        name='title'
                                                                        defaultValue={settings?.numberChartTemplate?.config?.title || ''}
                                                                        onChange={handleNumberChartTemplate5TitleDescription}
                                                                    />
                                                                </FormControl>
                                                                <FormControl>
                                                                    <Typography variant="body2" sx={{ paddingBottom: '0.2rem' }}> Description </Typography>
                                                                    <TextField
                                                                        className='re-new-settings-input'
                                                                        type="text"
                                                                        name='description'
                                                                        defaultValue={settings?.numberChartTemplate?.config?.description || ''}
                                                                        onChange={handleNumberChartTemplate5TitleDescription}
                                                                    />
                                                                </FormControl>
                                                            </>
                                                        )
                                                        : null
                                                }
                                            </FormGroup>
                                        </AccordionDetails>
                                    </Accordion>
                                </Box>
                            )
                            : null
                    }

                    {
                        // reportDetails?.reportDetails?.chartType === 'table'
                    }
                    <HyperLinks
                        reportDetails={reportDetails}
                        commonFields={commonFields}
                        setCommonFields={setCommonFields}
                        updateReportDetails={updateReportDetails}
                        setHyperlinkCount={setHyperlinkCount}
                        hyperlinkCount={hyperlinkCount}
                    />
                    {
                        measures?.length ?
                            <Box className="report-new-charts">
                                <Box className='new-report-settings-navitem' onClick={() => setOpenMetricsModal(true)}>
                                    <Typography variant='h6' className="font-weight-500 form_input_label">Metrics</Typography>
                                    <DropDownIcon className='re-dropdown-icon' />
                                </Box>

                            </Box>
                            : null
                    }
                    <MergeReportSetting 
                    reportDetails={reportDetails}
                    updateReportDetails={updateReportDetails}
                    />



                </Box>
            </div>

            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className="modal-root re-modal"
                open={openMetricsModal}
                closeAfterTransition
            >
                <Fade in={openMetricsModal}>
                    <Box className="modal-paper modal-box modal-sm re-modal-box" id="transition-modal-title">
                        <Box className="modal-header border-0" >
                            <Box className="re-modal-close-icon">
                                <CancelIcon onClick={() => setOpenMetricsModal(false)} />
                            </Box>

                            <Typography variant="subtitle1" className="modal-header-title" >{`Metrics`}</Typography>
                        </Box>
                        <Box className="modal-content re-modal-content pt-quarter" ref={modalRef}>
                            <>
                                {
                                    conditionalFormat?.map((format, index) => (
                                        <ReportMetrics key={index} closeModal={handleMetricsClose} format={format} index={index} reportDetails={reportDetails} handleConditionalFormat={handleConditionalFormat}
                                            removeFormat={removeFormat}
                                            conditionalFormatArr={conditionalFormat}
                                        />

                                        //ReportMetrics({key: index, closeModal: handleMetricsClose, format: format, index: index, reportDetails: reportDetails, handleConditionalFormat: handleConditionalFormat, removeFormat: removeFormat, conditionalFormatArr: conditionalFormat})

                                    ))
                                }
                                <Box className='re-modal-action-more'>
                                    <Button className='re-btn re-btn-plain' onClick={addMoreFormat}>
                                        <AddBtnIcon />
                                        <Typography className='re-btn-plain-label' variant='p'> Add</Typography>
                                    </Button>
                                </Box>
                            </>
                        </Box>
                    </Box>
                </Fade>
            </Modal>

            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className="modal-root re-modal"
                open={otherSettingsRowsPerPageModal}
                closeAfterTransition
            >
                <Fade in={otherSettingsRowsPerPageModal}>
                    <Box className="modal-paper modal-box modal-sm" id="transition-modal-title">
                        <Box className="modal-header border-0" >
                            <Typography variant="subtitle1" className="modal-header-title" >{`Set No of Rows per page`}</Typography>
                        </Box>
                        <Box className="modal-content re-modal-content">
                            <TextField onChange={e => setOtherSettingsData(prev => ({ ...otherSettingsData, pageSize: e?.target?.value }))} value={otherSettingsData?.pageSize} className="report_form_ui_input width-100 mb-1" placeholder="" /> <br />

                            <Box className="modal-footer text-right">
                                <Button onClick={e => handlePageSize('cancel')} color="error" className="re-btn re-btn-outline re-btn-separator cancel" variant="outlined" > Cancel </Button>
                                <Button onClick={e => handlePageSize('save')} color="primary" autoFocus className="re-btn re-btn-main submit" variant="contained"> Save </Button>
                            </Box>
                        </Box>

                    </Box>
                </Fade>
            </Modal>

            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className="modal-root re-modal"
                open={otherSettingsalignmentModal}
                closeAfterTransition
            >
                <Fade in={otherSettingsalignmentModal}>
                    <Box className="modal-paper modal-box modal-sm" id="transition-modal-title">
                        <Box className="modal-header border-0" >
                            <Typography variant="subtitle1" className="modal-header-title" >{`Set Alignment`}</Typography>
                        </Box>
                        <Box className="modal-content re-modal-content">

                            <Box className='re-form-group'  >
                                <FormControl className='width-100' >

                                    <Box className='re-custom-textfield' onClick={() => toggleTableHeaderDropdown()}>
                                        <Box className='re-custom-textfield-content'>
                                            <Typography className='re-custom-textfield-placeholder' variant='body2' >Table header</Typography>
                                        </Box>
                                        <Box className={`re-custom-textfield-rightitem ` + (customInputTableHeader ? `show` : ``)}>
                                            <DropDownIcon className="icon-dropdown" />
                                        </Box>
                                    </Box>
                                    <div className={`re-custom-textfield-dropdown ` + (customInputTableHeader ? `show` : ``)}  >
                                        <List >
                                            <ListItem onClick={() => customInputTableHeaderSelected('left')} className={`re-custom-textfield-alignment-icons ` + ((otherSettingsData?.alignment?.header === 'left') ? `selected` : ``)}>
                                                <ListItemIcon> <LeftAlignmentIcon /></ListItemIcon>
                                            </ListItem>
                                            <ListItem onClick={() => customInputTableHeaderSelected('center')} className={`re-custom-textfield-alignment-icons ` + ((otherSettingsData?.alignment?.header === 'center') ? `selected` : ``)}>
                                                <ListItemIcon> <CenterAlignmentIcon /></ListItemIcon>
                                            </ListItem>
                                            <ListItem onClick={() => customInputTableHeaderSelected('right')} className={`re-custom-textfield-alignment-icons ` + ((otherSettingsData?.alignment?.header === 'right') ? `selected` : ``)}>
                                                <ListItemIcon> <RightAlignmentIcon /></ListItemIcon>
                                            </ListItem>
                                        </List>
                                    </div>

                                </FormControl>
                            </Box>

                            <Box className='re-form-group'  >
                                <FormControl className='width-100' >

                                    <Box className='re-custom-textfield' onClick={() => toggleDimensionsDropdown()}>
                                        <Box className='re-custom-textfield-content'>
                                            <Typography className='re-custom-textfield-placeholder' variant='body2' >Dimensions</Typography>
                                        </Box>
                                        <Box className={`re-custom-textfield-rightitem ` + (customInputDimensions ? `show` : ``)}>
                                            <DropDownIcon className="icon-dropdown" />
                                        </Box>
                                    </Box>
                                    <div className={`re-custom-textfield-dropdown ` + (customInputDimensions ? `show` : ``)}  >
                                        <List >
                                            <ListItem onClick={() => customInputDimensionsSelected('left')} className={`re-custom-textfield-alignment-icons ` + ((otherSettingsData?.alignment?.dimensions === 'left') ? `selected` : ``)}>
                                                <ListItemIcon> <LeftAlignmentIcon /></ListItemIcon>
                                            </ListItem>
                                            <ListItem onClick={() => customInputDimensionsSelected('center')} className={`re-custom-textfield-alignment-icons ` + ((otherSettingsData?.alignment?.dimensions === 'center') ? `selected` : ``)}>
                                                <ListItemIcon> <CenterAlignmentIcon /></ListItemIcon>
                                            </ListItem>
                                            <ListItem onClick={() => customInputDimensionsSelected('right')} className={`re-custom-textfield-alignment-icons ` + ((otherSettingsData?.alignment?.dimensions === 'right') ? `selected` : ``)}>
                                                <ListItemIcon> <RightAlignmentIcon /></ListItemIcon>
                                            </ListItem>
                                        </List>
                                    </div>

                                </FormControl>
                            </Box>

                            <Box className="modal-footer text-right">
                                <Button onClick={() => handleAlignmentSetting('cancel')} color="error" className="re-btn re-btn-outline re-btn-separator cancel" variant="outlined" > Cancel </Button>
                                <Button onClick={e => handleAlignmentSetting('save')} color="primary" autoFocus className="re-btn re-btn-main submit" variant="contained"> Save </Button>
                            </Box>

                        </Box>



                    </Box>
                </Fade>
            </Modal>


        </RootStyle >
    );
}


function HyperLinks({ reportDetails, commonFields, updateReportDetails, setCommonFields, hyperlinkCount, setHyperlinkCount }) {
    const classes = useStyles();
    const [reportFields, setReportFields] = useState([])
    const [reportList, setReportList] = useState([]);
    const [publishedDashboard, setPublishedDashboard] = useState([]);
    const [currentHyperlinkAccordianIndex, setCurrentHyperlinkAccodianIndex] = useState(
        () => reportDetails?.reportDetails?.reportHyperlink.length - 1 || 0
    )
    useEffect(async () => {
        if (publishedDashboard.length === 0 && reportDetails?.reportDetails?.reportHyperlink[currentHyperlinkAccordianIndex]?.hyperlinkType === 'dashboard') {
            const response = await getPublishedDashboardList({ pageNo: 0, count: 1000 }); // needs to be changed
            if (response?.result?.length) {
                setPublishedDashboard(response.result)
            }
        }
    }, [currentHyperlinkAccordianIndex, reportDetails?.reportDetails?.reportHyperlink[currentHyperlinkAccordianIndex]?.hyperlinkType, publishedDashboard])

    useEffect(() => {
        let mount = true;
        (async () => {
            // let params = { type: 'superadmin' } //use this only in dev mode
            let params = { pagination: false }
            const response = await getReportsList(params)
            if (response && response?.result?.length && mount) {
                setReportList(response?.result)
            }

            if (reportDetails?.reportDetails) {
                let fields = []
                const { dimensions, measures } = reportDetails?.reportDetails;
                if (dimensions?.length) {
                    fields = [...fields, ...dimensions]
                }
                if (measures?.length) {
                    fields = [...fields, ...measures]
                }
                if (mount) {
                    setReportFields(fields)
                }
            }
        })();
        return () => {
            mount = false;
        }
    }, [])

    const getMeasureListByDataset = (dataSetId) => {
        return getMeasuresList({ dataSetId: dataSetId })
    }


    const getItemDisplayName = (itemText) => {
        const measures = reportDetails?.reportDetails?.measures;
        const dimensions = reportDetails?.reportDetails?.dimensions;
        let displayName;
        for (let meas of measures) {
            if (meas?.fieldName === itemText) {
                displayName = meas?.displayName;
                break;
            }
        }
        if (!displayName) {
            for (let dim of dimensions) {
                if (dim?.fieldName === itemText) {
                    displayName = dim?.displayName;
                    break;
                }
            }
        }

        return displayName ? displayName : itemText?.split('.')[1]
    }

    const handleAccordianClick = (index) => {
        if (currentHyperlinkAccordianIndex === index) {
            return
        }
        setCurrentHyperlinkAccodianIndex(index);
        // reset the dashboard selection
        setPublishedDashboard((prevState) => ({
            ...prevState,
            selectedDashboard: null,
        }));
    }

    const getReportColumnCount = () => {
        const { dimensions, measures } = reportDetails?.reportDetails;
        let length = 0;
        if (dimensions?.length) {
            length += dimensions?.length
        }
        if (measures?.length) {
            length += measures?.length
        }
        return length;
    }

    const handleSelectReport = async (e, index) => {
        let value = e
        if (value) {

            const { dataSetId, _id, reportName } = value
            const { dimensions } = reportDetails.reportDetails
            const measureList = await getMeasureListByDataset(dataSetId?._id);
            if (measureList?.result && measureList?.result.length && dimensions.length) {
                const commonField = dimensions.filter(dim => measureList.result.find(meas => dim?.fieldName.split('.')[1] === meas?.name))
                if (commonField && commonField.length) {
                    if (!commonFields.length) {
                        commonFields[0] = commonField
                    }
                    else {
                        commonFields[index] = commonField
                    }

                    setCommonFields(commonFields)
                }
            }
            reportDetails.reportDetails.reportHyperlink[index].hyperlinkReportId = { _id: _id, reportName: reportName };
            reportDetails.reportDetails.reportHyperlink[index].hyperlinkFilters = []
            updateReportDetails({ reportDetails: reportDetails.reportDetails })
        }
    }

    const handleSelectDashboard = async (value, index) => {
        if (value) {
            const { _id, dashboardName } = value
            reportDetails.reportDetails.reportHyperlink[index].hyperlinkDashboardId = { _id, dashboardName };
            updateReportDetails({ reportDetails: reportDetails.reportDetails })
        }
    }

    const handleSelectHyperLinkFilter = (e, index) => {
        const { value } = e.target;
        reportDetails.reportDetails.reportHyperlink[index].hyperlinkFilters = [...value];
        updateReportDetails({ reportDetails: reportDetails.reportDetails })

    }

    const handleDeleteHyperlink = () => {
        let count = 1;
        reportDetails.reportDetails.reportHyperlink = [{ hyperlinkColumn: '', hyperlinkReportId: {}, hyperlinkFilters: [], hyperlinkType: '', hyperlinkExtType: '', hyperlinkExtParams: [], hyperlinkExtQryParams: [{ name: '', field: '' }] }]
        setCommonFields([])
        updateReportDetails({ reportDetails: reportDetails.reportDetails })
        setHyperlinkCount(count)
    }

    const handleHyperLinkType = (e, index) => {
        const { value } = e?.target;
        if (value === 'int') {
            reportDetails.reportDetails.reportHyperlink[index].hyperlinkExtUrl = '';
            reportDetails.reportDetails.reportHyperlink[index].hyperlinkExtParams = [];
            reportDetails.reportDetails.reportHyperlink[index].hyperlinkExtQryParams = [{ name: '', field: '' }];
        }
        if (value === 'ext') {
            reportDetails.reportDetails.reportHyperlink[index].hyperlinkReportId = {};
            reportDetails.reportDetails.reportHyperlink[index].hyperlinkFilters = [];
        }
        if (value === 'dashboard') {
            reportDetails.reportDetails.reportHyperlink[index].hyperlinkReportId = {};
            reportDetails.reportDetails.reportHyperlink[index].hyperlinkFilters = [];
            reportDetails.reportDetails.reportHyperlink[index].hyperlinkExtUrl = '';
            reportDetails.reportDetails.reportHyperlink[index].hyperlinkExtParams = [];
            reportDetails.reportDetails.reportHyperlink[index].hyperlinkExtQryParams = [{ name: '', field: '' }];
        }
        reportDetails.reportDetails.reportHyperlink[index].hyperlinkType = value;
        updateReportDetails({ reportDetails: reportDetails.reportDetails })
    }

    const handleHyperlinkExternalUrl = (e, index) => {
        const { value } = e?.target;
        reportDetails.reportDetails.reportHyperlink[index].hyperlinkExtUrl = value;
        updateReportDetails({ reportDetails: reportDetails.reportDetails })
    }

    const handleExternalParamsType = (e, index) => {
        const { value } = e?.target;

        if (value === "params") {
            reportDetails.reportDetails.reportHyperlink[index].hyperlinkExtQryParams = [{ name: '', field: '' }]
        }
        else if (value === "queryParams") {
            reportDetails.reportDetails.reportHyperlink[index].hyperlinkExtParams = []
        }
        reportDetails.reportDetails.reportHyperlink[index].hyperlinkExtType = value;
        updateReportDetails({ reportDetails: reportDetails.reportDetails })
    }

    const handleExternalLinkWindowSettings = (e, index) => {
        const { value } = e?.target;
        reportDetails.reportDetails.reportHyperlink[index].hyperLinkExtWindow = value;
        updateReportDetails({ reportDetails: reportDetails.reportDetails })
    }

    const handleHyperlinkExtQueryName = (e, index, qryIndex) => {
        const { value } = e?.target;
        reportDetails.reportDetails.reportHyperlink[index].hyperlinkExtQryParams[qryIndex].name = value;
        updateReportDetails({ reportDetails: reportDetails.reportDetails })
    }

    const handleHyperlinkExtQueryField = (e, index, qryIndex) => {
        const { value } = e?.target;
        reportDetails.reportDetails.reportHyperlink[index].hyperlinkExtQryParams[qryIndex].field = value;
        updateReportDetails({ reportDetails: reportDetails.reportDetails })
    }

    const handlehyperlinkExtParams = (e, index) => {
        const { value } = e?.target;
        reportDetails.reportDetails.reportHyperlink[index].hyperlinkExtParams = value;
        updateReportDetails({ reportDetails: reportDetails.reportDetails })
    }

    const addHyperlinkQueryMenu = (index, qryIndex) => {
        if (!reportDetails.reportDetails.reportHyperlink[index].hyperlinkExtQryParams[qryIndex] || (reportDetails.reportDetails.reportHyperlink[index].hyperlinkExtQryParams[qryIndex] && (!reportDetails.reportDetails.reportHyperlink[index].hyperlinkExtQryParams[qryIndex]?.name || !reportDetails.reportDetails.reportHyperlink[index].hyperlinkExtQryParams[qryIndex]?.field))) {
            toast.error('Query Fields are required');
            return
        }
        reportDetails.reportDetails.reportHyperlink[index].hyperlinkExtQryParams.push({ name: '', field: '' })
        updateReportDetails({ reportDetails: reportDetails.reportDetails })
    }

    const removeHyperlinkQueryMenu = (index, qryIndex) => {
        reportDetails.reportDetails.reportHyperlink[index].hyperlinkExtQryParams.splice(qryIndex, 1)
        updateReportDetails({ reportDetails: reportDetails.reportDetails })
    }

    const handleSelectHyperLinkColumn = (e, index) => {
        e.stopPropagation();
        const value = e.target.value
        reportDetails.reportDetails.reportHyperlink[index].hyperlinkColumn = value;
        updateReportDetails({ reportDetails: reportDetails.reportDetails })
    }

    const addHyperlinkMenu = (index) => {
        if (reportDetails?.reportDetails?.reportHyperlink[index]) {
            const { hyperlinkColumn, hyperlinkReportId, hyperlinkFilters, hyperlinkType, hyperlinkExtUrl, } = reportDetails?.reportDetails?.reportHyperlink[index];

            if (!hyperlinkColumn) {
                toast.error('Hyperlink Column is required');
                return
            }
            else if (hyperlinkType === 'int' && !hyperlinkReportId) {
                toast.error('Report should be selected');
                return
            }
            else if (hyperlinkType === 'ext' && !hyperlinkExtUrl) {
                toast.error('URL is required');
                return
            }

            else if (commonFields[index]?.length && (!hyperlinkFilters || (hyperlinkFilters && !hyperlinkFilters?.length))) {
                toast.error('Hyperlink Fields are required');
                return
            }
            else {

                if (reportDetails.reportDetails.reportHyperlink && reportDetails.reportDetails.reportHyperlink.length) {

                    let fields = reportFields
                    for (let link of reportDetails.reportDetails.reportHyperlink) {
                        fields.forEach(f => {
                            if (f?.fieldName === link?.hyperlinkColumn)
                                f.isSelected = true
                        })
                    }

                    setReportFields(fields)
                }

                let count = hyperlinkCount + 1;
                setHyperlinkCount(count)
                reportDetails?.reportDetails?.reportHyperlink.push({ hyperlinkColumn: '', hyperlinkReportId: {}, hyperlinkFilters: [], hyperlinkType: '', hyperlinkExtType: '', hyperlinkExtParams: [], hyperlinkExtQryParams: [{ name: '', field: '' }] })

                setCurrentHyperlinkAccodianIndex(index + 1)
                updateReportDetails({ reportDetails: reportDetails.reportDetails })
            }
        }
        else {
            toast.error('Hyperlink Fields are required');
            return
        }

    }

    const removeHyperlinkMenu = (index) => {
        reportDetails.reportDetails.reportHyperlink.splice(index, 1);
        commonFields.splice(commonFields.length, 1)
        let count = hyperlinkCount - 1;
        if (reportDetails.reportDetails.reportHyperlink && reportDetails.reportDetails.reportHyperlink.length) {
            const { hyperlinkColumn } = reportDetails.reportDetails.reportHyperlink[index - 1]
            let fields = reportFields
            for (let f of fields) {
                if (f?.fieldName === hyperlinkColumn) {
                    f.isSelected = false
                    break
                }
            }

            setReportFields(fields)
        }

        setHyperlinkCount(count)
        setCommonFields(commonFields)
        updateReportDetails({ reportDetails: reportDetails.reportDetails })
    }

    const handleHyperlinkColumnsForDashboard = (e, index) => {
        const { value } = e?.target;
        reportDetails.reportDetails.reportHyperlink[index].hyperlinkColumnsForDashboard = value;
        updateReportDetails({ reportDetails: reportDetails.reportDetails })
    }
    
    if (reportDetails?.reportDetails?.chartType !== 'table' && reportDetails?.reportDetails?.chartType !== 'number') return null;

    const { reportHyperlink, measures = [], dimensions = [] } = reportDetails?.reportDetails;
    const measureAndDimensionFields = [...measures, ...dimensions];
    return (
        <Box className="report-new-charts">
            <Accordion className="filter_accordian" >
                <AccordionSummary className="filter_accordian_summary " expandIcon={<DropDownIcon />} id="hyper-links-settings">
                    <Typography variant='h6' className="font-weight-500 form_input_label"> Hyperlink</Typography>
                </AccordionSummary>
                <AccordionDetails className="filter_accordian_details">
                    <div>
                        {
                            reportHyperlink.map((link, index) => {
                                return (
                                    <Stack key={`hyperlink-stack-${index}`} direction="column" className="width-100" spacing={1} flexShrink={0} sx={{ my: 0 }}>
                                        <Accordion
                                            expanded={index === currentHyperlinkAccordianIndex}
                                            onClick={() => handleAccordianClick(index)}
                                            className="width-100">
                                            <AccordionSummary
                                                className="filter-box-item-summary"
                                                expandIcon={<DropDownIcon />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                            >

                                                {link?.hyperlinkColumn ?
                                                    <>
                                                        <LabelOutlinedIcon className="cm_measr_lbl" />

                                                        {getItemDisplayName(link.hyperlinkColumn)}
                                                    </>
                                                    : 'Add Hyperlink'}

                                            </AccordionSummary>
                                            <AccordionDetails className="filter-box-item-details">

                                                <FormGroup >
                                                    <Typography variant='h6' className="font-weight-500 form_input_label">Select Column</Typography>
                                                    <Select
                                                        // disabled={index !== Array.from(Array(hyperlinkCount).keys()).length - 1} 
                                                        onChange={e => handleSelectHyperLinkColumn(e, index)}
                                                        value={link.hyperlinkColumn}
                                                    >
                                                        {
                                                            reportFields?.length ? (reportFields?.map((dim, j) => {
                                                                if (index === 0) {
                                                                    return (
                                                                        <MenuItem key={j} value={dim?.fieldName}>
                                                                            {dim?.displayName || dim?.fieldName.split('.')[1]}
                                                                        </MenuItem>
                                                                    )
                                                                }
                                                                else if (index === Array.from(Array(hyperlinkCount).keys()).length - 1) {
                                                                    if (!dim?.isSelected) {
                                                                        return (
                                                                            <MenuItem key={j} value={dim?.fieldName}>
                                                                                {dim?.displayName || dim?.fieldName.split('.')[1]}
                                                                            </MenuItem>
                                                                        )
                                                                    } else { return null }
                                                                }
                                                                else {
                                                                    return (
                                                                        <MenuItem key={j} value={dim?.fieldName}>
                                                                            {dim?.displayName || dim?.fieldName.split('.')[1]}
                                                                        </MenuItem>
                                                                    )
                                                                }
                                                            })

                                                            ) : null
                                                        }

                                                    </Select>

                                                    <Typography variant='h6' className="font-weight-500 form_input_label">Hyperlink Type</Typography>

                                                    <Select
                                                        value={link.hyperlinkType}
                                                        onChange={e => handleHyperLinkType(e, index)}
                                                    >
                                                        <MenuItem value="int">Internal</MenuItem>
                                                        <MenuItem value="ext">External</MenuItem>
                                                        <MenuItem value="dashboard">Dashboard</MenuItem>
                                                    </Select>

                                                    {
                                                        link.hyperlinkType === 'int' && (
                                                            <>
                                                                <Typography variant='h6' className="font-weight-500 form_input_label">Report List</Typography>

                                                                <ReactSelect
                                                                    classNamePrefix="select"
                                                                    options={reportList}
                                                                    menuPlacement='auto'
                                                                    getOptionLabel={(option) => option.reportName}
                                                                    getOptionValue={(option) => option.reportName}
                                                                    value={link.hyperlinkReportId}
                                                                    onChange={(val) => handleSelectReport(val, index)}
                                                                />

                                                                {

                                                                    (commonFields?.length && commonFields[index] && commonFields[index]?.length) ? (
                                                                        <>
                                                                            <Typography variant='h6' className="font-weight-500 form_input_label">Select Fields</Typography>
                                                                            <Select
                                                                                multiple
                                                                                style={{ maxWidth: '100%', overflow: 'hidden' }}
                                                                                onChange={e => handleSelectHyperLinkFilter(e, index)}
                                                                                renderValue={(selected) => selected.join(",")}
                                                                                value={link.hyperlinkFilters}
                                                                            >
                                                                                {
                                                                                    commonFields[index]?.map((c, k) => (
                                                                                        <MenuItem
                                                                                            key={k}
                                                                                            value={c?.fieldName.split('.')[1]}>
                                                                                            <Checkbox
                                                                                                className="form_checkbox"
                                                                                                checked={link.hyperlinkFilters?.indexOf(c?.fieldName.split('.')[1]) > -1}
                                                                                            />
                                                                                            <ListItemText className="text-plain">
                                                                                                {c?.displayName || c?.fieldName.split('.')[1]}
                                                                                            </ListItemText>
                                                                                        </MenuItem>


                                                                                    ))
                                                                                }

                                                                            </Select>
                                                                        </>
                                                                    ) : null
                                                                }

                                                            </>
                                                        )
                                                    }
                                                    {

                                                        link.hyperlinkType === 'ext' && (
                                                            //For External Linking starts
                                                            <>
                                                                <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                                                    <Typography variant='h6' className="font-weight-500 form_input_label">External URL</Typography>

                                                                    <Controls.Input
                                                                        placeholder="External URL"
                                                                        className="report_form_ui_input" label=""
                                                                        onChange={e => handleHyperlinkExternalUrl(e, index)}
                                                                        value={link.hyperlinkExtUrl}
                                                                    />

                                                                </FormControl>

                                                                <Typography variant='h6' className="font-weight-500 form_input_label">External Link Opening</Typography>

                                                                <Select
                                                                    value={link.hyperLinkExtWindow}
                                                                    defaultValue={"modal"}
                                                                    onChange={e => handleExternalLinkWindowSettings(e, index)}
                                                                >
                                                                    <MenuItem value="modal">
                                                                        Modal
                                                                    </MenuItem>
                                                                    <MenuItem value="same_window">
                                                                        Same window
                                                                    </MenuItem>
                                                                    <MenuItem value="new_window">
                                                                        New window
                                                                    </MenuItem>
                                                                </Select>
                                                            { reportDetails?.reportDetails?.chartType !== 'number' && <>
                                                                <Typography variant='h6' className="font-weight-500 form_input_label">Params Type</Typography>

                                                                <Select
                                                                    value={link.hyperlinkExtType}
                                                                    onChange={e => handleExternalParamsType(e, index)}
                                                                >
                                                                    <MenuItem value="params">
                                                                        Use Params
                                                                    </MenuItem>
                                                                    <MenuItem value="qryParams">
                                                                        Use Query Parmas
                                                                    </MenuItem>
                                                                </Select>

                                                                {
                                                                    link.hyperlinkExtType === 'params' && (
                                                                        <>
                                                                            <Typography variant="body2" sx={{ paddingBottom: '0.2rem' }}>Select Feilds</Typography>

                                                                            <Select
                                                                                className="report_form_ui_input_select pl-0"
                                                                                variant="outlined"
                                                                                multiple
                                                                                value={link.hyperlinkExtParams}
                                                                                renderValue={(selected) => selected.join(",")}
                                                                                size='small'
                                                                                onChange={e => handlehyperlinkExtParams(e, index)}
                                                                            >

                                                                                {
                                                                                    reportDetails?.reportDetails?.dimensions?.length && (
                                                                                        reportDetails?.reportDetails?.dimensions.map((dim, i) => (
                                                                                            <MenuItem key={`${i}-${dim.fieldName}`} className="menu-item flex" value={dim?.fieldName.split('.')[1]}  >
                                                                                                <Checkbox
                                                                                                    className="form_checkbox"
                                                                                                    checked={link.hyperlinkExtParams?.indexOf(dim?.fieldName.split('.')[1]) > -1}
                                                                                                />
                                                                                                <ListItemText className="text-plain">
                                                                                                    {dim?.displayName || dim?.fieldName.split('.')[1]}
                                                                                                </ListItemText>
                                                                                            </MenuItem>
                                                                                        ))
                                                                                    )
                                                                                }
                                                                                {
                                                                                    reportDetails?.reportDetails?.measures?.length && (
                                                                                        reportDetails?.reportDetails?.measures.map((dim, i) => (
                                                                                            <MenuItem key={`${i}-${dim.fieldName}`} className="menu-item flex" value={dim?.fieldName.split('.')[1]}  >
                                                                                                <Checkbox
                                                                                                    className="form_checkbox"
                                                                                                    checked={link.hyperlinkExtParams?.indexOf(dim?.fieldName.split('.')[1]) > -1}
                                                                                                />
                                                                                                <ListItemText className="text-plain">
                                                                                                    {dim?.displayName || dim?.fieldName.split('.')[1]}
                                                                                                </ListItemText>
                                                                                            </MenuItem>
                                                                                        ))
                                                                                    )
                                                                                }
                                                                            </Select>
                                                                        </>
                                                                    )
                                                                }

                                                                {
                                                                    link.hyperlinkExtType === 'qryParams' && (
                                                                        <>
                                                                            {
                                                                                link.hyperlinkExtQryParams && (
                                                                                    link.hyperlinkExtQryParams.map((qry, qryIndex) => {
                                                                                        return (
                                                                                            <>
                                                                                                <Accordion
                                                                                                    key={qryIndex} className="filter_accordian" >
                                                                                                    <AccordionSummary className="filter_accordian_summary " expandIcon={<DropDownIcon />} id="legendSettings">
                                                                                                        <Typography variant='h6' className="font-weight-500 form_input_label"> Query Params</Typography>
                                                                                                    </AccordionSummary>
                                                                                                    <AccordionDetails className="filter_accordian_details">
                                                                                                        <FormControl variant="outlined" className={classes.formControl + ' width-100'}>
                                                                                                            <Typography variant="body2" sx={{ paddingBottom: '0.2rem' }}>Name</Typography>
                                                                                                            <Controls.Input
                                                                                                                className="report_form_ui_input"
                                                                                                                label=""
                                                                                                                onChange={e => handleHyperlinkExtQueryName(e, index, qryIndex)}
                                                                                                                value={qry?.name}
                                                                                                            />
                                                                                                            <Typography variant="body2" sx={{ paddingBottom: '0.2rem' }}>Select Field</Typography>
                                                                                                            <Select
                                                                                                                // disabled={qryIndex !== reportDetails?.reportDetails?.reportHyperlink[index]?.hyperlinkExtQryParams.length - 1}
                                                                                                                onChange={e => handleHyperlinkExtQueryField(e, index, qryIndex)}
                                                                                                                value={qry?.field}
                                                                                                            >

                                                                                                                {
                                                                                                                    reportDetails?.reportDetails?.dimensions?.length && reportDetails?.reportDetails?.dimensions.map((dim, i) => (
                                                                                                                        <MenuItem key={`${i}-${dim.fieldName}`} value={dim?.fieldName.split('.')[1]}>
                                                                                                                            {dim?.displayName || dim?.fieldName.split('.')[1]}
                                                                                                                        </MenuItem>
                                                                                                                    ))
                                                                                                                }
                                                                                                                {
                                                                                                                    reportDetails?.reportDetails?.measures?.length && reportDetails?.reportDetails?.measures.map((dim, i) => (
                                                                                                                        <MenuItem key={`${i}-${dim.fieldName}`} value={dim?.fieldName.split('.')[1]}>
                                                                                                                            {dim?.displayName || dim?.fieldName.split('.')[1]}
                                                                                                                        </MenuItem>
                                                                                                                    ))
                                                                                                                }

                                                                                                            </Select>
                                                                                                        </FormControl>
                                                                                                    </AccordionDetails>
                                                                                                </Accordion>

                                                                                                <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-evenly', marginTop: '8px' }}>

                                                                                                    {
                                                                                                        link.hyperlinkExtQryParams.length - 1 === qryIndex && (
                                                                                                            <Button onClick={e => addHyperlinkQueryMenu(index, qryIndex)}>Add</Button>
                                                                                                        )
                                                                                                    }

                                                                                                    {
                                                                                                        link.hyperlinkExtQryParams.length > 1 && (
                                                                                                            <Button onClick={e => removeHyperlinkQueryMenu(index, qryIndex)}>Remove</Button>
                                                                                                        )
                                                                                                    }

                                                                                                </Box>
                                                                                            </>
                                                                                        )
                                                                                    })
                                                                                )
                                                                            }
                                                                        </>
                                                                    )
                                                                }
                                                                </>
                                                            }
                                                            </>
                                                        )
                                                    }
                                                    {
                                                        link.hyperlinkType === 'dashboard' ? (
                                                            <>
                                                                <Typography variant='h6' className="font-weight-500 form_input_label">Dashboard list</Typography>
                                                                <ReactSelect
                                                                    classNamePrefix="select"
                                                                    options={publishedDashboard}
                                                                    menuPlacement='auto'
                                                                    getOptionLabel={(option) => option.dashboardName}
                                                                    getOptionValue={(option) => option.dashboardName}
                                                                    defaultValue={link?.hyperlinkDashboardId || null}
                                                                    onChange={(val) => handleSelectDashboard(val, index)}
                                                                />
                                                            </>
                                                        ) : null
                                                    }
                                                    {
                                                        link.hyperlinkType === 'dashboard' && reportDetails?.reportDetails?.chartType !== 'number'
                                                            ? (
                                                                <>
                                                                    <Typography variant='h6' className="font-weight-500 form_input_label" style={{ marginBottom: '5px' }}>Select Cloumns</Typography>
                                                                    <FormControl>
                                                                        <InputLabel id="report-columns">Columns</InputLabel>
                                                                        <Select
                                                                            labelId="report-columns"
                                                                            multiple
                                                                            value={link.hyperlinkColumnsForDashboard || []}
                                                                            onChange={e => handleHyperlinkColumnsForDashboard(e, index)}
                                                                            input={<OutlinedInput label="Columns" />}
                                                                            renderValue={(selected) => {
                                                                                return selected.map(item => item.split('.')[1] || '').join(', ')
                                                                            }}
                                                                        >
                                                                            {
                                                                                measureAndDimensionFields.map((field, i) => (
                                                                                    <MenuItem key={i} value={field?.fieldName}>
                                                                                        <Checkbox checked={link.hyperlinkColumnsForDashboard?.includes(field.fieldName)} />
                                                                                        <ListItemText className="text-plain" primary={field?.displayName || field?.fieldName?.split('.')?.[1]} />
                                                                                    </MenuItem>
                                                                                ))
                                                                            }
                                                                        </Select>
                                                                    </FormControl>
                                                                </>
                                                            )
                                                            : null
                                                    }

                                                </FormGroup>
                                            </AccordionDetails>
                                        </Accordion>

                                        <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-evenly', marginTop: '8px' }}>
                                            {
                                                (
                                                    index === reportHyperlink.length - 1 &&
                                                    reportHyperlink.length <= getReportColumnCount() - 1
                                                ) ?
                                                    (
                                                        <Button onClick={e => addHyperlinkMenu(index)}>Add More</Button>
                                                    ) : null
                                            }
                                            {/* <Button variant='outlined'>Save</Button> */}
                                            {/* {

                                                Array.from(Array(hyperlinkCount).keys()).length !== 1 && index === Array.from(Array(hyperlinkCount).keys()).length - 1 ?

                                                    <Button onClick={e => removeHyperlinkMenu(index)}>Remove</Button>
                                                    : null
                                            } */}
                                            <Button onClick={e => removeHyperlinkMenu(index)}>Remove</Button>
                                        </Box>

                                    </Stack>
                                )
                            })
                        }

                        <Button variant='outlined' onClick={handleDeleteHyperlink}>Delete</Button>
                        {/* <Button variant='outlined' onClick= {handleApplyHyperLink}>Apply</Button> */}
                    </div>
                </AccordionDetails>
            </Accordion>
        </Box>
    )
}
